/* Editorial product-card display names. Full product data is unchanged.
 * Responsive whole-word alternatives in luxivo-rrp.js also cover future products. */
window.LuxivoCardNames = Object.freeze({
  "lacoste-parka-hooded-jacket-black": "Parka Hooded Jacket",
  "rains-women-1201-jacket-green": "1201 Jacket",
  "rains-1201-jacket-green": "1201 Jacket",
  "peak-performance-helium-down-hood-jacket-black": "Helium Down Jacket",
  "lyle-scott-merino-crew-knit-smoke": "Merino Crew Knit",
  "lyle-scott-merino-crew-knit-grey": "Merino Crew Knit",
  "lyle-scott-merino-crew-knit-khaki": "Merino Crew Knit",
  "lyle-scott-regular-tee-khaki": "T-shirt",
  "lyle-scott-merino-crew-knit-darknavy": "Merino Crew Knit",
  "lyle-scott-merino-crew-knit-cove": "Merino Crew Knit",
  "lyle-scott-merino-half-zip-knit-kahki": "Merino Half-Zip Knit",
  "lyle-scott-l-s-tee-black": "L/S Tee",
  "tommy-hilfiger-3-pack-v-neck-tee-white": "3-pack V-Neck Tee",
  "tommy-hilfiger-7-pack-repeat-trunks-black": "7-pack Repeat Trunks",
  "tommy-hilfiger-regular-3-pack-tee-otq": "3-pack T-shirt",
  "tommy-hilfiger-3-pack-v-neck-tee-black": "3-pack V-Neck Tee",
  "tommy-hilfiger-regular-3-pack-tee-otj": "3-pack T-shirt",
  "tommy-hilfiger-5-pack-trunks-black": "5-pack Trunks",
  "ralph-lauren-oxford-slim-pique-shirt-stripe": "Oxford Stripe Shirt",
  "calvin-klein-women-lift-bralette-grey": "Lift Bralette",
  "hugo-boss-regular-full-zip-knit-black": "Regular Zip Knit",
  "nike-park-logo-hoodie-black": "Park Logo Hoodie",
  "hugo-boss-contrast-paddy-polo-gree": "Contrast Paddy Polo",
  "hugo-boss-3-pack-regular-t-shirt-season": "3-pack T-shirt",
  "hugo-boss-paddy-pro-contrast-polo-navy": "Paddy Pro Polo",
  "hugo-boss-3-pack-regular-t-shirt-sand": "3-pack T-shirt",
  "calvin-klein-women-icon-bralette-2-pack-grey": "Icon Bralette 2-pack",
  "les-deux-otto-linen-shorts-forrest": "Otto Linen Shorts",
  "mcs-half-zip-fleece-jacket-army": "Half Zip Fleece Jacket",
  "mcs-hugh-puffer-jacket-black": "Hugh Puffer Jacket",
  "mcs-sweatshirt-skyler-grey": "Sweatshirt Skyler",
  "u-s-polo-assn-women-t-shirt-amy-peachy": "T-shirt Amy",
  "ralph-lauren-full-zip-double-knit-track-top-black": "Double Knit Track Top",
  "calvin-klein-women-bikini-briefs-3-pack-black": "Bikini Briefs 3-pack",
  "nike-club-tee-navy": "Club Tee",
  "nike-women-s-s-academy-polo-white": "S/S Academy Polo",
  "nike-dri-fit-shorts-sky": "Dri-FIT Shorts",
  "les-deux-raphael-shorts-black": "Raphael Shorts",
  "les-deux-logo-polo-india": "Logo Polo",
  "les-deux-norregaard-l-s-tee-black": "Nørregaard L/S Tee",
  "hugo-boss-3-pack-regular-t-shirt-961": "3-pack T-shirt",
  "tommy-hilfiger-regular-3-pack-tee-navy": "3-pack T-shirt",
  "tommy-hilfiger-regular-3-pack-tee-osk": "3-pack T-shirt",
  "tommy-hilfiger-regular-3-pack-tee-multi05m": "3-pack T-shirt",
  "hugo-boss-3-pack-regular-t-shirt-984": "3-pack T-shirt",
  "hugo-boss-3-pack-regular-t-shirt-497": "3-pack T-shirt",
  "hugo-boss-leather-timon-belt-3-5-black": "Leather Timon Belt 3.5",
  "armani-ea7-id-logo-zip-hoodie-green": "EA7 ID Logo Zip Hoodie",
  "u-s-polo-assn-polo-alfred-mediterranea": "Polo Alfred",
  "u-s-polo-assn-linen-shirt-bolt-stripe": "Linen Shirt Bolt Stripe",
  "u-s-polo-assn-t-shirt-ls-brolin-navy": "T-shirt LS Brolin",
  "u-s-polo-assn-3-pack-socks-aubrey-black": "3-pack Socks Aubrey",
  "resterods-10-pack-bamboo-socks-black": "10-pack Bamboo Socks",
  "hugo-boss-6-pack-regular-t-shirt-multi": "6-pack T-shirt",
  "u-s-polo-assn-6-pack-t-shirt-arjun-multi": "6-pack T-shirt Arjun",
  "mcs-6-pack-t-shirt-ohio-multi": "6-pack T-shirt Ohio",
  "mcs-sweatshirt-skyler-navy": "Sweatshirt Skyler",
  "u-s-polo-assn-briggs-swim-shorts-mediterranea": "Briggs Swim Shorts",
  "u-s-polo-assn-briggs-swim-shorts-placid": "Briggs Swim Shorts",
  "u-s-polo-assn-polo-claus-striped": "Polo Claus Striped",
  "u-s-polo-assn-women-maise-cardigan-white": "Maise Cardigan",
  "u-s-polo-assn-women-t-shirt-maja-white": "T-shirt Maja",
  "u-s-polo-assn-women-mira-pull-up-striped-pants": "Mira Stripe Pants",
  "resterods-bamboo-sweatshirt-navy": "Bamboo Sweatshirt",
  "mcs-regular-rob-denim-shorts-blue": "Rob Denim Shorts",
  "mcs-regular-rob-denim-shorts-black": "Rob Denim Shorts",
  "mcs-regular-s-s-shirt-jackson-otter": "S/S Shirt Jackson",
  "mcs-regular-s-s-shirt-jackson-navy": "S/S Shirt Jackson",
  "mcs-regular-s-s-linen-shirt-bombay": "S/S Linen Shirt",
  "mcs-regular-s-s-linen-shirt-army": "S/S Linen Shirt",
  "mcs-regular-s-s-linen-shirt-navy": "S/S Linen Shirt",
  "mcs-regular-s-s-linen-shirt-white": "S/S Linen Shirt",
  "mcs-swim-shorts-irving-stripe-army": "Swim Irving Stripe",
  "calvin-klein-trunks-9-pack-icon-mix": "Trunks 9-pack Icon",
  "hugo-boss-prime-pique-polo-regular-pink": "Prime Pique Polo",
  "hugo-boss-basic-logo-hoodie-black": "Basic Logo Hoodie",
  "hugo-boss-zestart-track-zip-jacket-navy": "Zestart Zip Jacket",
  "hugo-boss-prime-pique-polo-regular-marine": "Prime Pique Polo",
  "hugo-boss-prime-pique-polo-regular-white": "Prime Pique Polo",
  "hugo-boss-prime-pique-polo-regular-black": "Prime Pique Polo",
  "hugo-boss-tchup-crew-tee-white": "Tchup Crew Tee",
  "u-s-polo-assn-women-stripe-t-shirt-carla-navy": "Stripe T-shirt Carla",
  "u-s-polo-assn-women-t-shirt-maja-sand": "T-shirt Maja",
  "u-s-polo-assn-women-mia-top-blue": "Mia Top",
  "u-s-polo-assn-women-mia-top-white": "Mia Top",
  "u-s-polo-assn-women-casandra-top-navy": "Casandra Top",
  "u-s-polo-assn-women-margo-shorts-pink": "Margo Shorts",
  "u-s-polo-assn-women-melodie-shirt-pink": "Melodie Shirt",
  "u-s-polo-assn-women-knit-cardigan-kimmi-black": "Knit Cardigan Kimmi",
  "u-s-polo-assn-3-pack-t-shirt-arjun-multi-fwb": "Arjun 3-pack",
  "u-s-polo-assn-3-pack-t-shirt-arjun-multi2": "Arjun 3-pack",
  "u-s-polo-assn-t-shirt-nord-black": "T-shirt NORD",
  "u-s-polo-assn-cotton-shorts-cedric-navy": "Cotton Shorts Cedric",
  "u-s-polo-assn-cotton-shorts-cedric-black": "Cotton Shorts Cedric",
  "u-s-polo-assn-cotton-shorts-cedric-grey": "Cotton Shorts Cedric",
  "u-s-polo-assn-s-s-shirt-nathan-stripe": "S/S Shirt Nathan Stripe",
  "u-s-polo-assn-s-s-shirt-nathan-blue": "S/S Shirt Nathan",
  "u-s-polo-assn-linen-shirt-bolt-forest": "Linen Shirt Bolt",
  "u-s-polo-assn-2-pack-polo-alfred-navyplacid": "2-Pack Polo Alfred",
  "u-s-polo-assn-polo-alfredo-navy": "Polo Alfredo",
  "u-s-polo-assn-polo-alfred-peach": "Polo Alfred",
  "u-s-polo-assn-2-pack-polo-alfred-whitenavy": "2-Pack Polo Alfred",
  "armani-ea7-core-id-track-top-scarab": "EA7 Core ID Track Top",
  "hugo-boss-3-pack-stretch-cotton-boxers-multi": "3-pack Cotton Boxers",
  "u-s-polo-assn-women-katie-half-zip-sweatshirt-navy": "Katie Half-Zip Sweat",
  "u-s-polo-assn-women-sweatshirt-helen-grey": "Sweatshirt Helen",
  "u-s-polo-assn-women-sweatshirt-helen-navy": "Sweatshirt Helen",
  "u-s-polo-assn-women-india-tapered-pants-navy": "India Tapered Pants",
  "u-s-polo-assn-women-knit-cardigan-kimmi-grey": "Knit Cardigan Kimmi",
  "u-s-polo-assn-women-knit-cardigan-kimmi-navy": "Knit Cardigan Kimmi",
  "mcs-rick-regular-denim-jeans-dark": "Rick Jeans",
  "u-s-polo-assn-dakota-cap-navy": "Dakota Denim Cap",
  "mcs-rick-regular-denim-jeans-blue": "Rick Jeans",
  "u-s-polo-assn-sweatshirt-adler-army": "Sweatshirt Adler",
  "mcs-6-pack-bamboo-boxers-black": "6-pack Bamboo Boxers",
  "ralph-lauren-featherweight-shirt-andover": "Andover Shirt",
  "mcs-knit-sweater-ellison-mink": "Knit Ellison",
  "u-s-polo-assn-sweatshirt-adler-marine": "Sweatshirt Adler",
  "u-s-polo-assn-sweatshirt-adler-melange": "Sweatshirt Adler",
  "u-s-polo-assn-sweatshirt-adler-dark": "Sweatshirt Adler",
  "u-s-polo-assn-sweatshirt-adler-ocean": "Sweatshirt Adler",
  "u-s-polo-assn-3-pack-bamboo-trunks-black": "3-pack Bamboo Trunks",
  "u-s-polo-assn-6-pack-bamboo-trunks-navy": "6-pack Bamboo Trunks",
  "u-s-polo-assn-oscar-full-zip-sweatshirt-navy": "Oscar Zip Sweatshirt",
  "u-s-polo-assn-t-shirt-nord-blue": "T-shirt NORD",
  "u-s-polo-assn-polo-alfredo-black": "Polo Alfredo",
  "u-s-polo-assn-westi-vest-black": "Westi Vest",
  "mcs-hoodie-chris-beetle": "Hoodie Chris",
  "mcs-eli-half-zip-knit-beetle": "Eli Half-Zip Knit",
  "mcs-eli-half-zip-knit-black": "Eli Half-Zip Knit",
  "u-s-polo-assn-half-zip-knit-brison-black": "Half-Zip Knit Brison",
  "u-s-polo-assn-knit-sweater-adair-cloud": "Knit Adair",
  "mcs-sweatshirt-skyler-beetle": "Sweatshirt Skyler",
  "ellesse-ornari-full-zip-hoodie-black": "Ornari Zip Hoodie",
  "hugo-boss-zestart-track-zip-jacket-black": "Zestart Zip Jacket",
  "les-deux-piece-tee-raven": "Piece Tee",
  "hugo-boss-1-4-zip-zetrust-logo-sweater-black": "1/4 Zip Zetrust Knit",
  "tommy-hilfiger-l-s-3-pack-regular-tee-multi": "L/S 3-pack T-shirt",
  "calvin-klein-trunks-3-pack-icon-oaz": "Trunks 3-pack Icon",
  "calvin-klein-trunks-9-pack-icon-black": "Trunks 9-pack Icon",
  "u-s-polo-assn-chelsea-boots-black": "Chelsea Boots",
  "u-s-polo-assn-ohio-laced-boots-black": "Ohio Laced Boots",
  "u-s-polo-assn-steve-sneakers-white": "Steve Sneakers",
  "hugo-boss-omaris-jacket-black": "Puffer Jacket",
  "hugo-boss-odenis-jacket-black": "Quilted Jacket",
  "hugo-boss-odeno-2-gilet-black": "Classic Gilet",
  "hugo-boss-contrast-paddy-polo-bla": "Contrast Paddy Polo",
  "hugo-boss-contrast-paddy-polo-hvid": "Contrast Paddy Polo",
  "hugo-boss-contrast-logo-hoodie-black": "Contrast Logo Hoodie",
  "hugo-boss-saggy-zip-logo-hoodie-black": "Saggy Zip Logo Hoodie",
  "hugo-boss-tracksuit-pants-black": "Tracksuit Pants",
  "hugo-boss-patch-logo-sweatshirt-black-1": "Patch Logo Sweatshirt",
  "hugo-boss-patch-wetalk-logo-hoodie-black-1": "Wetalk Logo Hoodie",
  "hugo-boss-sweatpants-sestart-black": "Sweatpants Sestart",
  "tommy-hilfiger-pima-knit-gloves-black": "Pima Knit Gloves",
  "tommy-hilfiger-tjm-leather-wash-bag-black": "TJM Leather Wash Bag",
  "tommy-hilfiger-women-essential-down-coat-army": "Essential Down Coat",
  "tommy-hilfiger-women-modern-puffer-jacket-navy": "Modern Puffer Jacket",
  "u-s-polo-assn-nor-beanie-black": "Nor Beanie",
  "u-s-polo-assn-mika-cap-black": "Mika Cap",
  "u-s-polo-assn-6-pack-bamboo-trunks-black": "6-pack Bamboo Trunks",
  "u-s-polo-assn-zip-hoodie-otto-navy": "Zip Hoodie Otto",
  "u-s-polo-assn-2-pack-polo-alfred-navy": "2-Pack Polo Alfred",
  "u-s-polo-assn-2-pack-polo-alfred-black": "2-Pack Polo Alfred",
  "u-s-polo-assn-artur-jacket-navy": "Artur Jacket",
  "u-s-polo-assn-artur-jacket-black": "Artur Jacket",
  "u-s-polo-assn-puffer-vest-eugene-black": "Puffer Vest Eugene",
  "u-s-polo-assn-cable-knit-signature-grey": "Cable Knit Signature",
  "u-s-polo-assn-t-shirt-ls-brolin-black": "T-shirt LS Brolin",
  "u-s-polo-assn-3-pack-t-shirt-arjun-multi": "Arjun 3-pack",
  "u-s-polo-assn-sweatshirt-adler-forest": "Sweatshirt Adler",
  "hugo-boss-half-zip-polo-black": "Half Zip Polo",
  "lyle-scott-lounge-jogger-black": "Lounge Jogger",
  "lyle-scott-ombre-check-overshirt": "Ombre Overshirt",
  "tommy-hilfiger-archive-98-sneaker-black": "Archive 98 Sneaker",
  "tommy-hilfiger-leather-sneaker-low-top-black": "Sneaker Low Top",
  "tommy-hilfiger-retro-basket-sneaker-black": "Retro Basket",
  "tommy-hilfiger-down-jacket-black": "Down Jacket",
  "tommy-hilfiger-crew-knit-sweater-black": "Crew Knit",
  "mcs-regular-shirt-greg-blue": "Shirt Greg",
  "mcs-regular-shirt-greg-navy": "Shirt Greg",
  "mcs-regular-shirt-greg-white": "Shirt Greg",
  "mcs-knit-sweater-ellison-beetle": "Knit Ellison",
  "mcs-3-pack-t-shirt-ohio-darkness": "Ohio 3-pack",
  "mcs-t-shirt-texas-sand": "T-shirt Texas",
  "mcs-t-shirt-texas-black": "T-shirt Texas",
  "mcs-t-shirt-texas-navy": "T-shirt Texas",
  "mcs-t-shirt-texas-beetle": "T-shirt Texas",
  "mcs-t-shirt-texas-white": "T-shirt Texas",
  "mcs-3-pack-longsleeve-t-shirt-jack-multi": "Jack 3-pack L/S",
  "mcs-3-pack-longsleeve-t-shirt-jack-darkness": "Jack 3-pack L/S",
  "mcs-3-pack-longsleeve-t-shirt-jack-black": "Jack 3-pack L/S",
  "mcs-pique-polo-navy": "Pique Polo",
  "mcs-pique-polo-beetle": "Pique Polo",
  "mcs-clement-half-zip-black": "Clement Half-Zip",
  "mcs-clement-half-zip-beetle": "Clement Half-Zip",
  "resterods-dean-cardigan-black": "Dean Cardigan",
  "resterods-dean-cardigan-grey": "Dean Cardigan",
  "resterods-box-fit-tee-black": "Box Fit Tee",
  "resterods-box-fit-tee-white": "Box Fit Tee",
  "lyle-scott-regular-print-tee-navy": "Print Tee",
  "resterods-michael-pullover-black": "Michael Pullover",
  "resterods-michael-pullover-brown": "Michael Pullover",
  "resterods-kane-knit-polo-black": "Kane Knit Polo",
  "resterods-nas-chino-pant-black": "Nas Chino Pant",
  "cr7-lux-bathrobe-black": "Lux Bathrobe",
  "resterods-frank-jacket-army": "Timeless Puffer Jacket",
  "resterods-jay-hoodie-black": "Jay Hoodie",
  "resterods-sandman-pyjamas-pant-stripes": "Sandman Pyjamas",
  "resterods-frank-jacket-black": "Timeless Puffer Jacket",
  "resterods-armstrong-overshirt-sand": "Armstrong Overshirt",
  "resterods-armstrong-overshirt-black": "Armstrong Overshirt",
  "resterods-davis-shirt-dark": "Davis Shirt",
  "resterods-davis-shirt-stripe": "Davis Shirt Stripe",
  "lyle-scott-oxford-shirt-regular-olive": "Oxford Shirt Regular",
  "u-s-polo-assn-women-pique-dress-ebba-cerulean": "Pique Dress EBBA",
  "u-s-polo-assn-women-pique-dress-ebba-navy": "Pique Dress EBBA",
  "u-s-polo-assn-women-ika-polo-dress-sand": "IKA Polo Dress",
  "u-s-polo-assn-women-ika-polo-dress-pink": "IKA Polo Dress",
  "u-s-polo-assn-women-ika-polo-dress-navy": "IKA Polo Dress",
  "u-s-polo-assn-women-linen-pants-ibi-sand": "Linen Pants IBI",
  "u-s-polo-assn-women-linen-pants-ibi-white": "Linen Pants IBI",
  "u-s-polo-assn-women-linen-shorts-hena-white": "Linen Shorts HENA",
  "u-s-polo-assn-women-linen-shorts-hena-sand": "Linen Shorts HENA",
  "u-s-polo-assn-women-iben-cotton-shorts-navy": "Iben Cotton Shorts",
  "u-s-polo-assn-women-iben-cotton-shorts-sand": "Iben Cotton Shorts",
  "u-s-polo-assn-women-isa-linen-shirt-sand": "ISA Linen Shirt",
  "u-s-polo-assn-women-isa-linen-shirt-white": "ISA Linen Shirt",
  "u-s-polo-assn-women-polo-hariet-pink": "Polo HARIET",
  "u-s-polo-assn-women-polo-hariet-navy": "Polo HARIET",
  "u-s-polo-assn-women-rib-polo-helga-sand": "Rib Polo Helga",
  "u-s-polo-assn-women-rib-polo-helga-white": "Rib Polo Helga",
  "u-s-polo-assn-women-rib-polo-helga-navy": "Rib Polo Helga",
  "u-s-polo-assn-women-casandra-top-black": "Casandra Top",
  "u-s-polo-assn-chino-shorts-crockery": "Chino Shorts",
  "u-s-polo-assn-chino-shorts-navy": "Chino Shorts",
  "u-s-polo-assn-malik-cotton-shorts-crockery": "Malik Cotton Shorts",
  "u-s-polo-assn-malik-cotton-shorts-navy": "Malik Cotton Shorts",
  "u-s-polo-assn-s-s-shirt-nathan-navy": "S/S Shirt Nathan",
  "u-s-polo-assn-s-s-shirt-nathan-white": "S/S Shirt Nathan",
  "u-s-polo-assn-polo-nis-navy": "Polo NIS",
  "u-s-polo-assn-t-shirt-nord-navy": "T-shirt NORD",
  "u-s-polo-assn-t-shirt-nord-white": "T-shirt NORD",
  "hugo-boss-season-patch-polo-466": "Season Patch Polo",
  "hugo-boss-season-patch-polo-271": "Season Patch Polo",
  "hugo-boss-season-patch-polo-462": "Season Patch Polo",
  "hugo-boss-paddy-pro-contrast-polo-355": "Paddy Pro Polo",
  "hugo-boss-paddy-pro-contrast-polo-009": "Paddy Pro Polo",
  "hugo-boss-contrast-paddy-polo-285": "Contrast Paddy Polo",
  "hugo-boss-contrast-paddy-polo-412": "Contrast Paddy Polo",
  "hugo-boss-contrast-paddy-polo-355": "Contrast Paddy Polo",
  "tommy-hilfiger-women-organic-badge-skirt-olive": "Organic Badge Skirt",
  "hugo-boss-paddy-pro-contrast-polo-white": "Paddy Pro Polo",
  "hugo-boss-paddy-pro-contrast-polo-sand": "Paddy Pro Polo",
  "hugo-boss-contrast-paddy-polo-111": "Contrast Paddy Polo",
  "hugo-boss-contrast-paddy-polo-blacken": "Contrast Paddy Polo",
  "hugo-boss-contrast-paddy-polo-blackout": "Contrast Paddy Polo",
  "hugo-boss-contrast-paddy-polo-clearblue": "Paddy Polo Clear",
  "hugo-boss-3-pack-power-boxer-brief-multi": "3-pack Power Boxers",
  "tommy-hilfiger-swim-shorts-side-logo-dark": "Swim Shorts Side Logo",
  "hugo-boss-5-pack-stretch-cotton-trunks-multi-1": "5-pack Trunks",
  "hugo-boss-tanktop-3-pack-white": "TankTop 3-pack",
  "hugo-boss-relegant-poplin-shirt-navy": "Relegant Poplin Shirt",
  "hugo-boss-relegant-poplin-shirt-blue": "Relegant Poplin Shirt",
  "hugo-boss-relegant-poplin-shirt-white": "Relegant Poplin Shirt",
  "hugo-boss-thinking-logo-tee-white": "Thinking Logo Tee",
  "hugo-boss-thinking-logo-tee-black": "Thinking Logo Tee",
  "hugo-boss-thinking-logo-tee-navy": "Thinking Logo Tee",
  "hugo-boss-logo-slides-black": "Logo Slides",
  "hugo-boss-surfley-sand-slides-dark": "Surfley Sand Slides",
  "hugo-boss-titanium-evo-sneakers-blackout1": "Titanium Evo",
  "hugo-boss-titanium-evo-sneakers-white": "Titanium Evo Sneakers",
  "hugo-boss-titanium-evo-sneakers-black": "Titanium Evo Sneakers",
  "tommy-hilfiger-women-5-pack-thong-new": "5-Pack Thong NEW",
  "skechers-women-go-walk-sneakers-white": "Go Walk Sneakers",
  "skechers-women-graceful-sneakers-gold": "Graceful Sneakers",
  "skechers-women-go-walk-sneakers-black": "Go Walk Sneakers",
  "skechers-women-go-walk-sneakers-muave": "Go Walk Sneakers",
  "skechers-women-go-run-sneakers-light": "GO RUN Sneakers",
  "skechers-women-go-run-sneakers-black": "GO RUN Sneakers",
  "skechers-bobs-sport-b-flex-sneakers-white": "BOBS Sport B Flex",
  "skechers-edgeride-sneaker-white": "Edgeride Sneaker",
  "skechers-edgeride-sneaker-black": "Edgeride Sneaker",
  "skechers-max-cushioning-sneakers-white": "Max Cushioning",
  "skechers-slip-in-court-sneakers-white": "Slip In Court Sneakers",
  "skechers-track-broader-sneakers-blackout": "Track Broader",
  "skechers-lightweight-track-sneaker-black": "Light Track Sneaker",
  "skechers-slip-in-sport-sneakers-black": "Slip In Sport Sneakers",
  "lyle-scott-linen-shirt-regular-navy": "Linen Shirt Regular",
  "lyle-scott-linen-shirt-regular-sand": "Linen Shirt Regular",
  "u-s-polo-assn-6-pack-socks-bo-white": "6-pack Socks BO",
  "u-s-polo-assn-6-pack-socks-bo-black": "6-pack Socks BO",
  "mcs-swim-shorts-irving-stripe-blue": "Swim Irving Stripe",
  "mcs-swim-shorts-garland-blue": "Garland Swim",
  "mcs-swim-shorts-garland-army": "Swim Shorts Garland",
  "mcs-swim-shorts-garland-navy": "Swim Shorts Garland",
  "u-s-polo-assn-swim-shorts-black": "Swim Shorts",
  "u-s-polo-assn-swim-shorts-navy": "Swim Shorts",
  "hugo-boss-3-pack-v-neck-regular-t-shirt-essential": "3-pack V-Neck T-shirt",
  "claudio-5-pack-tennis-socks-black": "5-Pack Tennis Socks",
  "claudio-5-pack-tennis-socks-white": "5-Pack Tennis Socks",
  "u-s-polo-assn-jacket-owe-black": "Jacket Owe",
  "u-s-polo-assn-women-full-length-jane-tights-black": "Jane Tights",
  "u-s-polo-assn-women-jill-vest-pink": "JILL Vest",
  "u-s-polo-assn-women-jill-vest-black": "JILL Vest",
  "u-s-polo-assn-women-jill-vest-navy": "JILL Vest",
  "claudio-5-pack-t-shirt-white": "5-Pack T-shirt",
  "claudio-5-pack-t-shirt-black": "5-Pack T-shirt",
  "claudio-10-pack-comfort-trunks-black": "10-pack Trunks",
  "claudio-5-pack-comfort-trunks-black": "5-pack Trunks",
  "resterods-swim-shorts-quick-dry-beige": "Quick Dry Swim Shorts",
  "resterods-swim-shorts-quick-dry-print": "Quick Dry Swim Shorts",
  "resterods-regular-chino-shorts-chin-sand": "Regular Chino Shorts",
  "resterods-regular-chino-shorts-chin-black": "Regular Chino Shorts",
  "calvin-klein-trunks-3-pack-icon-multi": "Trunks 3-pack Icon",
  "calvin-klein-trunks-3-pack-icon-xwb": "Trunks 3-pack Icon",
  "calvin-klein-trunks-3-pack-icon-black": "Trunks 3-pack Icon",
  "u-s-polo-assn-women-joy-jacket-pink": "Joy Jacket Creole",
  "u-s-polo-assn-women-joy-jacket-navy": "Joy Jacket",
  "u-s-polo-assn-women-joy-jacket-black": "Joy Jacket",
  "u-s-polo-assn-women-gina-oxford-shirt-white": "Gina Oxford Shirt",
  "u-s-polo-assn-women-gina-oxford-shirt-blue": "Gina Oxford Shirt",
  "u-s-polo-assn-women-may-knit-cloud": "May Knit",
  "u-s-polo-assn-women-l-s-t-shirt-chanett-blue": "L/S Tee Chanett Azure",
  "u-s-polo-assn-women-l-s-t-shirt-chanett-pink": "Chanett L/S Tee",
  "u-s-polo-assn-women-l-s-t-shirt-chanett-green": "L/S Tee Chanett Green",
  "u-s-polo-assn-women-l-s-t-shirt-chanett-navy": "L/S T-shirt Chanett",
  "u-s-polo-assn-women-l-s-t-shirt-carlotta-black": "L/S T-shirt Carlotta",
  "u-s-polo-assn-women-v-neck-t-shirt-assia-white": "V-Neck T-shirt Assia",
  "u-s-polo-assn-women-v-neck-t-shirt-assia-dubarry": "V-Neck T-shirt Assia",
  "u-s-polo-assn-women-t-shirt-amy-dubarry": "T-shirt Amy",
  "u-s-polo-assn-women-v-neck-t-shirt-assia-black": "V-Neck T-shirt Assia",
  "u-s-polo-assn-women-t-shirt-amy-sand": "T-shirt Amy",
  "u-s-polo-assn-women-t-shirt-amy-cerulean": "T-shirt Amy",
  "u-s-polo-assn-regular-fit-strech-chinos-grey": "Strech Chino",
  "u-s-polo-assn-jacket-mark-puffer-black": "Jacket Mark Puffer",
  "u-s-polo-assn-maks-puffer-vest-black": "Maks Puffer Vest",
  "u-s-polo-assn-regular-fit-strech-chinos-black": "Strech Chino",
  "u-s-polo-assn-regular-fit-strech-chinos-navy": "Strech Chino",
  "u-s-polo-assn-malo-pique-sweatshirt-crockery": "Malo Piqué Sweatshirt",
  "u-s-polo-assn-malo-pique-sweatshirt-navy": "Malo Piqué Sweatshirt",
  "parajumpers-sena-down-puffer-jacket-black": "Sena Down Puffer",
  "parajumpers-patch-tee-navy": "Patch Tee",
  "parajumpers-patch-polo-navy": "Patch Polo",
  "parajumpers-hiram-hooded-hybrid-jacket-black": "Hiram Hybrid Jacket",
  "parajumpers-vince-hybrid-jacket-black": "Vince Hybrid Jacket",
  "tommy-hilfiger-3-pack-essential-boxers-black": "3-pack Boxers",
  "tommy-hilfiger-tank-top-3-pack-black": "Tank Top 3-pack",
  "tommy-hilfiger-regular-3-pack-tee-black": "3-pack T-shirt",
  "tommy-hilfiger-logo-s-s-tee-grey": "Logo S/S Tee",
  "tommy-hilfiger-stretch-poplin-shirt-blue": "Stretch Poplin Shirt",
  "under-armour-icon-polo-navy": "Icon Polo",
  "under-armour-icon-polo-white": "Icon Polo",
  "under-armour-icon-polo-black": "Icon Polo",
  "under-armour-infinite-pro-2-running-sneakers-white": "Infinite Pro Sneaker",
  "under-armour-performance-tech-socks-3-pack-black": "Tech Socks 3-pack",
  "under-armour-performance-tech-socks-3-pack-white": "Tech Socks 3-pack",
  "lyle-scott-regular-polo-shirt-green": "Polo Shirt",
  "lyle-scott-regular-polo-shirt-cove": "Polo Shirt",
  "lyle-scott-regular-polo-shirt-gunmetal": "Polo Shirt",
  "lyle-scott-regular-tee-cove": "T-shirt",
  "u-s-polo-assn-shirt-flex-calvert-stripe": "Calvert Stripe",
  "u-s-polo-assn-cable-knit-signature-cloud": "Cable Knit Signature",
  "u-s-polo-assn-cable-knit-signature-navy": "Cable Knit Signature",
  "u-s-polo-assn-v-neck-t-shirt-cem-black": "V-Neck T-shirt Cem",
  "u-s-polo-assn-half-zip-knit-brison-crockery": "Half-Zip Knit Brison",
  "u-s-polo-assn-knit-sweater-adair-crockery": "Knit Adair",
  "u-s-polo-assn-polo-alfred-crockery": "Polo Alfred",
  "u-s-polo-assn-t-shirt-arjun-crockery": "T-shirt Arjun",
  "nike-vi-s-s-training-tee-gold": "VI S/S Training Tee",
  "nike-vi-s-s-training-tee-bordeaux": "VI S/S Training Tee Dark",
  "nike-vi-l-s-training-tee-blue": "VI L/S Training Tee",
  "tommy-hilfiger-regular-3-pack-tee-white": "3-pack T-shirt",
  "tommy-hilfiger-regular-linen-shirt-sand": "Regular Linen Shirt",
  "tommy-hilfiger-regular-linen-shirt-carbon": "Regular Linen Shirt",
  "tommy-hilfiger-regular-linen-s-s-shirt-faded-olive": "S/S Shirt",
  "tommy-hilfiger-regular-scanton-shorts-navy": "Scanton Shorts",
  "tommy-hilfiger-core-padded-vest-black": "Core Padded Vest",
  "tommy-hilfiger-straight-denton-jeans-faded": "Straight Denton Jeans",
  "tommy-hilfiger-leather-basket-sneaker-white": "Basket Sneaker",
  "tommy-hilfiger-straight-denton-chino-pants-grey": "Denton Chino Pants",
  "tommy-hilfiger-straight-denton-chino-pants-navy": "Denton Chino Pants",
  "tommy-hilfiger-straight-denton-jeans-darkindigo": "Denton Jeans Dark",
  "tommy-hilfiger-straight-denton-jeans-lightindigo": "Denton Jeans Light",
  "tommy-hilfiger-straight-denton-jeans-black": "Straight Denton Jeans",
  "tommy-hilfiger-v-neck-1985-pima-knit-black": "V-Neck 1985 Pima Knit",
  "tommy-hilfiger-1985-pima-knit-grey": "1985 Pima Knit",
  "tommy-hilfiger-1985-pima-knit-navy": "1985 Pima Knit",
  "tommy-hilfiger-1985-pima-knit-black": "1985 Pima Knit",
  "tommy-hilfiger-flex-poplin-shirt-white": "Flex Poplin Shirt",
  "tommy-hilfiger-flex-poplin-shirt-sky": "Flex Poplin Shirt",
  "tommy-hilfiger-flex-poplin-shirt-black": "Flex Poplin Shirt",
  "tommy-hilfiger-straight-ryan-regular-jeans-dark": "Bootcut Ryan Jeans",
  "tommy-hilfiger-chest-logo-tee-white": "Chest Logo Tee",
  "tommy-hilfiger-chest-logo-tee-black": "Chest Logo Tee",
  "tommy-hilfiger-swim-shorts-mid-length-navy-1": "Mid-Length Swim",
  "tommy-hilfiger-swim-shorts-mid-length-black-1": "Mid-Length Swim",
  "tommy-hilfiger-scanton-slim-jeans-faded": "Scanton Slim Jeans",
  "tommy-hilfiger-scanton-slim-jeans-black": "Austin Slim Jeans",
  "tommy-hilfiger-austin-slim-jeans-dark": "Austin Slim Jeans",
  "tommy-hilfiger-regular-2-pack-l-s-tee-white-blackie": "2-pack L/S Tee",
  "tommy-hilfiger-plaque-belt-3-5-black": "Plaque Belt 3.5",
  "tommy-hilfiger-v-neck-logo-knit-black": "Luxury V-Neck Knit",
  "tommy-hilfiger-logo-knit-navy": "Luxury Knit Pullover",
  "tommy-hilfiger-logo-knit-black": "Luxury Knit Pullover",
  "tommy-hilfiger-arch-l-s-tee-black": "Arch L/S Tee",
  "tommy-hilfiger-l-s-classic-polo-black": "L/S Classic Polo",
  "tommy-hilfiger-1-4-zip-sweatshirt-grey": "1/4 Zip Sweatshirt",
  "tommy-hilfiger-1-4-zip-sweatshirt-navy": "1/4 Zip Sweatshirt",
  "tommy-hilfiger-essential-logo-hoodie-black": "Essential Logo Hoodie",
  "tommy-hilfiger-essential-logo-hoodie-navy": "Essential Logo Hoodie",
  "tommy-hilfiger-essential-logo-hoodie-grey": "Essential Logo Hoodie",
  "tommy-hilfiger-organic-logo-tee-navy": "Organic Logo Tee",
  "tommy-hilfiger-organic-logo-tee-black": "Organic Logo Tee",
  "tommy-hilfiger-organic-logo-tee-grey": "Organic Logo Tee",
  "tommy-hilfiger-organic-logo-tee-white": "Organic Logo Tee",
  "tommy-hilfiger-stretch-poplin-shirt-white": "Stretch Poplin Shirt",
  "tommy-hilfiger-flag-polo-navy": "Flag Polo",
  "tommy-hilfiger-scanton-chino-shorts-black": "Scanton Chino Shorts",
  "tommy-hilfiger-l-s-logo-sleeve-tee-white": "L/S Logo Sleeve Tee",
  "tommy-hilfiger-turtleneck-logo-navy": "Turtleneck Logo",
  "tommy-hilfiger-l-s-logo-sleeve-tee-navy": "L/S Logo Sleeve Tee",
  "tommy-hilfiger-line-logo-sweatshirt-black": "Line Logo Sweatshirt",
  "tommy-hilfiger-line-logo-sweatshirt-grey": "Line Logo Sweatshirt",
  "tommy-hilfiger-cotton-knit-pullover-black": "Cotton Knit Pullover",
  "tommy-hilfiger-l-s-logo-sleeve-tee-black": "L/S Logo Sleeve Tee",
  "tommy-hilfiger-slim-l-s-tee-black": "Slim L/S Tee",
  "tommy-hilfiger-padded-vest-navy": "Padded Vest",
  "tommy-hilfiger-slim-l-s-tee-navy": "Slim L/S Tee",
  "tommy-hilfiger-italics-logo-sweatshirt-black": "Italics Logo Sweat",
  "tommy-hilfiger-signature-card-holder-black": "Signature Card Holder",
  "tommy-hilfiger-business-card-holder-black": "Business Card Holder",
  "tommy-hilfiger-essential-knit-v-neck-pullover-navy": "Knit V-Neck Knit",
  "tommy-hilfiger-flag-ribbed-jumper-navy": "Ribbed Flag Knit",
  "tommy-hilfiger-essential-knit-pullover-grey": "Knit Pullover",
  "tommy-hilfiger-essential-knit-pullover-black": "Knit Pullover",
  "tommy-hilfiger-classic-hoodie-black": "Classic Hoodie",
  "tommy-hilfiger-classic-hoodie-grey": "Classic Hoodie",
  "tommy-hilfiger-classic-hoodie-navy": "Classic Hoodie",
  "tommy-hilfiger-classic-polo-white": "Classic Polo",
  "tommy-hilfiger-leather-card-holder-black": "Leather Card Holder",
  "tommy-hilfiger-classic-polo-navy": "Classic Polo",
  "tommy-hilfiger-classic-polo-black": "Classic Polo",
  "tommy-hilfiger-3-pack-premium-trunks-nrw": "3-pack Premium Trunks",
  "tommy-hilfiger-slip-on-sneaker-white": "Slip On Sneaker",
  "tommy-hilfiger-colorblock-logo-s-s-tee-grey": "Colorblock S/S Tee",
  "tommy-hilfiger-crew-hwk-sweatshirt-grey": "Crew HWK Sweatshirt",
  "tommy-hilfiger-crew-hwk-sweatshirt-navy": "Crew HWK Sweatshirt",
  "tommy-hilfiger-logo-s-s-tee-navy": "Logo S/S Tee",
  "tommy-hilfiger-logo-s-s-tee-black": "Logo S/S Tee",
  "tommy-hilfiger-track-pant-hwk-navy": "Track Pant HWK",
  "tommy-hilfiger-logo-crew-sweatshirt-black": "Logo Crew Sweatshirt",
  "tommy-hilfiger-logo-crew-sweatshirt-navy": "Logo Crew Sweatshirt",
  "tommy-hilfiger-3-pack-premium-briefs-black": "3-pack Premium Briefs",
  "tommy-hilfiger-3-pack-premium-trunks-peacoat": "3-pack Trunks Multi",
  "tommy-hilfiger-3-pack-crew-neck-tee-black": "3-pack Crew Tee",
  "tommy-hilfiger-3-pack-premium-trunks-multi": "3-pack Premium Trunks",
  "tommy-hilfiger-regular-scanton-shorts-army": "Scanton Shorts",
  "tommy-hilfiger-regular-scanton-shorts-white": "Scanton Shorts",
  "tommy-hilfiger-regular-scanton-shorts-black": "Scanton Shorts",
  "tommy-hilfiger-scanton-slim-denim-shorts-casual": "Scanton Slim Shorts",
  "tommy-hilfiger-scanton-slim-denim-shorts-bright": "Scanton Slim Shorts",
  "tommy-hilfiger-classic-polo-army": "Classic Polo",
  "tommy-hilfiger-straight-denton-jeans-ohio": "Denton Jeans Ohio",
  "tommy-hilfiger-1-4-zip-1985-pima-knit-grey": "1/4 Zip 1985 Pima Knit",
  "tommy-hilfiger-flex-poplin-shirt-navy": "Flex Poplin Shirt",
  "tommy-hilfiger-core-padded-jacket-black": "Core Padded Jacket",
  "tommy-hilfiger-straight-ryan-regular-jeans-light": "Straight Ryan Jeans",
  "tommy-hilfiger-swim-shorts-recycled-mid-length-black": "Recycled Swim Shorts",
  "tommy-hilfiger-curved-logo-tee-white": "Curved Logo Tee",
  "tommy-hilfiger-scanton-regular-denim-shorts-dark": "Scanton Denim Shorts",
  "tommy-hilfiger-scanton-slim-jeans-dark": "Scanton Slim Jeans",
  "tommy-hilfiger-austin-slim-jeans-light": "Austin Slim Jeans",
  "tommy-hilfiger-oxford-logo-shirt-blue": "Oxford Logo Shirt",
  "tommy-hilfiger-straight-denton-jeans-light": "Straight Denton Jeans",
  "tommy-hilfiger-tee-graphic-logo-black": "Tee Graphic Logo",
  "tommy-hilfiger-shorts-brooklyn-beige": "Brooklyn Shorts",
  "tommy-hilfiger-shorts-brooklyn-black": "Brooklyn Shorts",
  "tommy-hilfiger-scanton-chino-shorts-navy": "Scanton Chino Shorts",
  "tommy-hilfiger-3-pack-boxers-waistband-logo-admiral": "3-pack Trunks",
  "tommy-hilfiger-3-pack-boxers-waistband-logo-midnight": "3-pack Trunks",
  "tommy-hilfiger-skate-leather-sneaker-black": "Skate Leather Sneaker",
  "tommy-hilfiger-turtleneck-logo-black": "Turtleneck Logo",
  "tommy-hilfiger-chino-slim-pants-grey": "Chino Slim Pants",
  "tommy-hilfiger-slim-l-s-tee-white": "Slim L/S Tee",
  "tommy-hilfiger-chino-slim-pants-army": "Chino Slim Pants",
  "tommy-hilfiger-essential-1-4-zip-grey": "Essential 1/4 Zip",
  "tommy-hilfiger-classic-sweat-black": "Classic Sweat",
  "tommy-hilfiger-stretch-poplin-shirt-black": "Stretch Poplin Shirt",
  "tommy-hilfiger-zip-logo-hoodie-black": "Zip Logo Hoodie",
  "tommy-hilfiger-cotton-silk-v-neck-black": "Cotton Silk V Neck Knit",
  "tommy-hilfiger-cotton-silk-knit-pullover-black": "Cotton Silk Knit",
  "tommy-hilfiger-scanton-slim-fit-denim-jeans-flag-logo": "Scanton Slim Jeans",
  "tommy-hilfiger-scanton-slim-fit-jeans-denim-black-1": "Scanton Slim Jeans",
  "tommy-jeans-essential-chino-olive": "Essential Chino",
  "tommy-hilfiger-logo-s-s-tee-white": "Logo S/S Tee",
  "tommy-hilfiger-logo-l-s-tee-white": "Logo L/S Tee",
  "tommy-hilfiger-hoody-ls-hwk-navy": "Hoodie LS HWK",
  "tommy-hilfiger-3-pack-crew-neck-tee-multi": "3-pack Crew Tee",
  "tommy-hilfiger-3-pack-v-neck-premium-tee-black": "3-pack V-Neck Tee",
  "tommy-hilfiger-3-pack-premium-trunks-black": "3-pack Premium Trunks",
  "u-s-polo-assn-v-neck-t-shirt-cem-navy": "V-Neck T-shirt Cem",
  "u-s-polo-assn-v-neck-t-shirt-cem-white": "V-Neck T-shirt Cem",
  "mcs-jones-full-zip-laurel": "Jones Full-Zip",
  "mcs-knit-sweater-ellison-navy": "Knit Ellison",
  "mcs-knit-sweater-ellison-black": "Knit Ellison",
  "cr7-trunks-5-pack-multi": "Trunks 5-Pack",
  "mcs-3-pack-t-shirt-ohio-multi": "Ohio 3-pack",
  "mcs-3-pack-t-shirt-ohio-white": "Ohio 3-pack",
  "mcs-3-pack-t-shirt-ohio-black": "Ohio 3-pack",
  "mcs-denim-shirt-tim-dark": "Denim Shirt Tim",
  "mcs-jones-full-zip-black": "Jones Full-Zip",
  "mcs-jones-full-zip-navy": "Jones Full-Zip",
  "mcs-hoodie-chris-laurel": "Hoodie Chris",
  "mcs-hoodie-chris-navy": "Hoodie Chris",
  "mcs-hoodie-chris-black": "Hoodie Chris",
  "mcs-clement-half-zip-laurel": "Clement Half-Zip",
  "mcs-clement-half-zip-navy": "Clement Half-Zip",
  "mcs-sweatshirt-skyler-black": "Sweatshirt Skyler",
  "ralph-lauren-1-4-zip-logo-pullover-navy": "1/4 Zip Logo Pullover",
  "tommy-hilfiger-women-l-s-dress-rib-knit-fit-and-flare-black": "Fit & Flare Dress",
  "ralph-lauren-full-zip-double-knit-track-top-navy": "Double Knit Track Top",
  "peak-performance-helium-hybrid-down-jacket-black": "Helium Hybrid Jacket",
  "peak-performance-argon-hybrid-hooded-jacket-pine": "Argon Hybrid Jacket",
  "peak-performance-down-jacket-olive": "Down Jacket",
  "peak-performance-helium-hybrid-down-hooded-jacket-olive": "Helium Hybrid Jacket",
  "peak-performance-hybrid-helium-down-jacket-black": "Helium Hybrid",
  "nike-dri-fit-zip-pocket-shorts-black": "Dri-FIT Zip Shorts",
  "u-s-polo-assn-hoodie-brayden-navy": "Hoodie Brayden",
  "u-s-polo-assn-hoodie-brayden-black": "Hoodie Brayden",
  "u-s-polo-assn-t-shirt-arjun-placid": "T-shirt Arjun",
  "u-s-polo-assn-regular-denim-jeans-black": "Jeans",
  "u-s-polo-assn-regular-denim-jeans-dark": "Jeans",
  "peak-performance-women-essential-logo-sweatshirt-grey": "Essential Sweat",
  "calvin-klein-women-thongs-3-pack-black": "Thongs 3-pack",
  "calvin-klein-women-thongs-3-pack-multi": "Thongs 3-pack",
  "calvin-klein-women-briefs-3-pack-multi": "Briefs 3-pack",
  "calvin-klein-women-briefs-3-pack-black": "Briefs 3-pack",
  "lyle-scott-merino-half-zip-knit-grey": "Merino Half-Zip Knit",
  "lyle-scott-merino-turtleneck-black": "Merino Turtleneck",
  "lyle-scott-ribbed-half-zip-cove": "Ribbed Half-Zip",
  "lyle-scott-merino-half-zip-knit-cove": "Merino Half-Zip Knit",
  "lyle-scott-merino-half-zip-knit-navy": "Merino Half-Zip Knit",
  "lyle-scott-merino-half-zip-knit-black": "Merino Half-Zip Knit",
  "lyle-scott-cable-knit-washed": "Cable Knit Washed",
  "lyle-scott-cable-knit-grey": "Cable Knit",
  "hugo-boss-shirt-motion-logo-navy": "Shirt Motion Logo",
  "hugo-boss-shirt-motion-logo-black": "Shirt Motion Logo",
  "hugo-boss-shirt-motion-logo-white": "Shirt Motion Logo",
  "u-s-polo-assn-half-zip-knit-kevin-grey": "Half-Zip Knit Kevin",
  "u-s-polo-assn-jacket-henrik-winter-black": "Jacket Henrik Winter",
  "u-s-polo-assn-sweatshirt-kuno-navy": "Sweatshirt Kuno",
  "u-s-polo-assn-half-zip-pullover-kurt-grey": "Half-Zip Pullover Kurt",
  "u-s-polo-assn-half-zip-pullover-kurt-navy": "Half-Zip Pullover Kurt",
  "u-s-polo-assn-sweatshirt-kuno-black": "Sweatshirt Kuno",
  "resterods-nate-chino-pants-army": "Nate Chino Pants",
  "resterods-nate-chino-pants-black": "Nate Chino Pants",
  "resterods-oversize-tee-white": "Oversize Tee",
  "resterods-oversize-tee-black": "Oversize Tee",
  "resterods-oversize-tee-navy": "Oversize Tee",
  "resterods-wool-scarf-army": "Wool Scarf",
  "resterods-wool-scarf-grey": "Wool Scarf",
  "resterods-wool-scarf-sand": "Wool Scarf",
  "resterods-wool-scarf-black": "Wool Scarf",
  "resterods-knit-cardigan-black": "Knit Cardigan",
  "resterods-full-zip-knit-pullover-sand": "Full-Zip Knit Pullover",
  "resterods-full-zip-knit-pullover-navy": "Full-Zip Knit Pullover",
  "resterods-full-zip-knit-pullover-black": "Full-Zip Knit Pullover",
  "resterods-half-zip-knit-pullover-black": "Half-Zip Knit Pullover",
  "resterods-half-zip-knit-pullover-navy": "Half-Zip Knit Pullover",
  "resterods-half-zip-knit-pullover-sand": "Half-Zip Knit Pullover",
  "resterods-knit-pullover-sand": "Knit Pullover",
  "resterods-knit-pullover-navy": "Knit Pullover",
  "resterods-knit-pullover-black": "Knit Pullover",
  "resterods-polar-fleece-pullover-army": "Polar Fleece Pullover",
  "resterods-polar-fleece-pullover-grey": "Polar Fleece Pullover",
  "resterods-polar-fleece-pullover-black": "Polar Fleece Pullover",
  "resterods-trench-coat-black": "Trench Coat",
  "u-s-polo-assn-6-pack-trunks-black": "6-pack Trunks",
  "hugo-boss-3-pack-regular-t-shirt-999": "3-pack T-shirt",
  "hugo-boss-3-pack-regular-t-shirt-100": "3-pack T-shirt",
  "hugo-boss-slim-denim-jeans-dark": "Slim Denim Jeans",
  "hugo-boss-slim-denim-jeans-light": "Slim Denim Jeans",
  "hugo-boss-regular-denim-jeans-grey": "Jeans",
  "ralph-lauren-signature-dot-pants-black": "Liquid Dot Pants",
  "hugo-boss-padded-oden1-jacket-black": "Padded Oden1 Jacket",
  "hugo-boss-leather-structure-belt-4-0-black": "Structure Belt 4.0",
  "hugo-boss-leather-jor-belt-4-0-brown": "Leather Jor Belt 4.0",
  "hugo-boss-leather-jor-belt-4-0-black": "Leather Jor Belt 4.0",
  "hugo-boss-leather-jion-belt-3-5-black": "Leather Jion Belt 3.5",
  "hugo-boss-patch-wetalk-logo-hoodie-green": "Wetalk Logo Hoodie",
  "hugo-boss-patch-wetalk-logo-hoodie-beige": "Wetalk Logo Hoodie",
  "hugo-boss-knit-cashmere-blend-beige": "Knit Cashmere Blend",
  "hugo-boss-skaz-1-zip-up-sweatshirt-black-1": "Skaz 1 Zip-Up Sweat",
  "hugo-boss-saggy-1-zip-hoodie-black-1": "Saggy 1 Zip Hoodie",
  "hugo-boss-j_thor-2-puffer-jacket-blackout": "J_Thor 2 Puffer Jacket",
  "hugo-boss-titanium-evo-sneakers-grey": "Titanium Evo Sneakers",
  "lyle-scott-crew-sweat-sage": "Crew Sweat",
  "lyle-scott-crew-sweat-cove": "Crew Sweat",
  "lyle-scott-logo-hoodie-sage": "Logo Hoodie",
  "lyle-scott-loopback-quarter-zip-sage": "Cotton 1/4 Zip",
  "lyle-scott-loopback-quarter-zip-black": "Cotton 1/4 Zip",
  "lyle-scott-loopback-quarter-zip-navy": "Cotton 1/4 Zip",
  "u-s-polo-assn-knit-sweater-adair-greym": "Knit Adair",
  "u-s-polo-assn-6-pack-socks-malte-black": "6-pack Socks Malte",
  "u-s-polo-assn-full-zip-sweatshirt-eran-grey": "Zip Sweatshirt Eran",
  "u-s-polo-assn-half-zip-knit-brison-partridge": "Half-Zip Knit Brison",
  "u-s-polo-assn-polo-ls-brett-black": "Polo LS Brett",
  "u-s-polo-assn-polo-ls-brett-navy": "Polo LS Brett",
  "u-s-polo-assn-women-sweatshirt-adele-grey": "Sweatshirt Adele",
  "u-s-polo-assn-women-sweatshirt-adele-glow": "Sweatshirt Adele",
  "u-s-polo-assn-women-may-knit-mauve": "May Knit",
  "u-s-polo-assn-women-l-s-t-shirt-carlotta-glow": "L/S T-shirt Carlotta",
  "u-s-polo-assn-women-t-shirt-amy-glow": "T-shirt Amy",
  "under-armour-sportstyle-logo-tee-black": "Sportstyle Logo Tee",
  "under-armour-tech-boxed-tee-black": "Tech Boxed Tee",
  "under-armour-tech-tee-tiger": "Tech Tee Tiger Melange",
  "under-armour-rival-terry-sweatshirt-black": "Rival Terry Sweatshirt",
  "u-s-polo-assn-3-pack-t-shirt-arjun-white": "Arjun 3-pack",
  "u-s-polo-assn-3-pack-t-shirt-arjun-black": "Arjun 3-pack",
  "u-s-polo-assn-3-pack-t-shirt-arjun-navy": "Arjun 3-pack",
  "resterods-swim-shorts-premium-army": "Swim Shorts Light",
  "resterods-swim-shorts-premium-black": "Swim Shorts Premium",
  "resterods-hybrid-shorts-lightweight-army": "Hybrid Shorts Light",
  "resterods-hybrid-shorts-lightweight-black": "Hybrid Shorts Light",
  "calvin-klein-women-2-pack-bra-unlined-black-grey": "2-pack Bra Unlined",
  "calvin-klein-women-unlined-triangle-bralette-grey": "Triangle Bralette",
  "calvin-klein-women-unlined-triangle-bralette-black": "Triangle Bralette",
  "u-s-polo-assn-linen-shorts-jorge-navy": "Linen Shorts Jorge",
  "u-s-polo-assn-linen-shorts-jorge-crockery": "Linen Shorts Jorge",
  "u-s-polo-assn-linen-pants-ivan-crockery": "Linen Pants Ivan",
  "u-s-polo-assn-linen-pants-ivan-navy": "Linen Pants Ivan",
  "u-s-polo-assn-oxford-slim-shirt-erlin-blue": "Oxford Slim Shirt Erlin",
  "u-s-polo-assn-shirt-flex-calvert-crockery": "Shirt Flex Calvert",
  "resterods-cargo-shorts-lightweight-sand": "Cargo Shorts Light",
  "resterods-cargo-shorts-lightweight-army": "Cargo Shorts Light",
  "resterods-cargo-shorts-lightweight-black": "Cargo Shorts Light",
  "hugo-boss-contrast-paddy-polo-black": "Contrast Paddy Polo",
  "hugo-boss-linen-overshirt-beige": "Linen Overshirt",
  "u-s-polo-assn-women-eda-dress-navy": "Eda Dress",
  "u-s-polo-assn-women-linen-shorts-cornelia-navy": "Linen Shorts Cornelia",
  "u-s-polo-assn-women-linen-shorts-cornelia-sand": "Linen Shorts Cornelia",
  "u-s-polo-assn-women-linen-shorts-cornelia-white": "Linen Shorts Cornelia",
  "u-s-polo-assn-women-polo-alma-navy": "Polo Alma",
  "u-s-polo-assn-women-polo-alma-white": "Polo Alma",
  "u-s-polo-assn-women-v-neck-t-shirt-assia-cerulean": "V-Neck T-shirt Assia",
  "u-s-polo-assn-women-v-neck-t-shirt-assia-navy": "V-Neck T-shirt Assia",
  "u-s-polo-assn-linen-shirt-bolt-crockery": "Linen Shirt Bolt",
  "resterods-bamboo-shorts-sand": "Bamboo Shorts",
  "calvin-klein-3-pack-stretch-tee-white": "3-pack Stretch Tee",
  "u-s-polo-assn-women-l-s-t-shirt-chanett-cerulean": "L/S T-shirt Chanett",
  "u-s-polo-assn-women-l-s-t-shirt-chanett-peachy": "L/S T-shirt Chanett",
  "u-s-polo-assn-women-l-s-t-shirt-carlotta-cloud": "L/S T-shirt Carlotta",
  "u-s-polo-assn-polo-alfred-blue": "Polo Alfred",
  "u-s-polo-assn-shirt-esmar-navy": "Shirt Esmar",
  "u-s-polo-assn-women-l-s-t-shirt-carlotta-navy": "L/S T-shirt Carlotta",
  "u-s-polo-assn-shirt-flex-calvert-white": "Shirt Flex Calvert",
  "u-s-polo-assn-linen-shirt-bolt-navy": "Linen Shirt Bolt",
  "u-s-polo-assn-linen-shirt-bolt-white": "Linen Shirt Bolt",
  "parajumpers-crew-knit-sweater-army": "Crew Knit",
  "parajumpers-crew-knit-sweater-avio": "Crew Knit Dark",
  "parajumpers-lightweight-nylon-wind-jacket-black": "Nylon Wind Jacket",
  "parajumpers-full-zip-knit-sweatshirt-dark": "Zip Knit Sweat Dark",
  "parajumpers-basic-side-polo-grey": "Basic Side Polo Dark",
  "parajumpers-basic-side-polo-black": "Basic Side Polo",
  "parajumpers-full-zip-knit-sweatshirt-navy": "Zip Knit Sweatshirt",
  "parajumpers-patch-polo-canvas": "Patch Polo Canvas",
  "parajumpers-patch-polo-black": "Patch Polo",
  "tommy-hilfiger-women-tonal-side-tie-bikini-bottom-sky": "Side-Tie Bikini",
  "tommy-hilfiger-women-tonal-side-tie-bikini-bottom-black": "Side-Tie Bikini",
  "tommy-hilfiger-women-tonal-bikini-bottom-black": "Tonal Bikini Bottom",
  "tommy-hilfiger-women-vulc-sneaker-white": "Vulc Sneaker",
  "tommy-hilfiger-women-bikini-triangle-top-black": "Bikini Triangle Top",
  "tommy-hilfiger-women-bikini-triangle-top-sky": "Bikini Triangle Top",
  "hugo-boss-paddy-pro-contrast-polo-dark": "Paddy Pro Polo",
  "hugo-boss-zip-zayno-polo-antracit": "Zip Zayno Polo",
  "hugo-boss-titanium-evo-runn-sneakers-mix": "Titanium Evo",
  "hugo-boss-jonah-runn-sneakers-white": "Jonah Runn Sneakers",
  "hugo-boss-tracy-flip-flops-black": "Tracy Flip-Flops",
  "lacoste-regular-polo-navy": "Regular Polo",
  "lacoste-regular-polo-green": "Regular Polo",
  "lacoste-regular-polo-black": "Regular Polo",
  "u-s-polo-assn-performance-shorts-black": "Performance Shorts",
  "u-s-polo-assn-performance-shorts-grey": "Performance Shorts",
  "u-s-polo-assn-performance-shorts-navy": "Performance Shorts",
  "u-s-polo-assn-cotton-shorts-grey": "Cotton Shorts",
  "les-deux-suede-theodor-sneaker-dessert": "Theodor Sneaker",
  "les-deux-suede-theodor-sneaker-olive": "Theodor Sneaker",
  "tommy-hilfiger-women-slim-tube-top-white": "Slim Tube Top",
  "tommy-hilfiger-women-slim-tube-top-black": "Slim Tube Top",
  "tommy-hilfiger-women-essential-slim-dress-navy": "Essential Slim Dress",
  "tommy-hilfiger-women-essential-slim-dress-black": "Essential Slim Dress",
  "tommy-hilfiger-women-essential-strap-dress-white": "Essential Strap Dress",
  "tommy-hilfiger-women-essential-strap-dress-black": "Essential Strap Dress",
  "under-armour-tech-tee-camo": "Tech Tee Camo",
  "levis-405-regular-denim-shorts-black": "405 Denim Shorts",
  "levis-405-regular-denim-shorts-light": "405 Denim Shorts",
  "levis-405-regular-denim-shorts-neutral": "405 Denim Shorts",
  "les-deux-otto-linen-shorts-navy": "Otto Linen Shorts",
  "les-deux-otto-linen-shorts-dessert": "Otto Linen Shorts",
  "les-deux-patrick-linen-pants-navy": "Patrick Linen Pants",
  "les-deux-patrick-linen-pants-forrest": "Patrick Linen Pants",
  "les-deux-patrick-linen-pants-dessert": "Patrick Linen Pants",
  "les-deux-linen-kris-shirt-navy": "Linen Kris Shirt",
  "les-deux-linen-kris-shirt-olive": "Linen Kris Shirt",
  "les-deux-linen-kris-shirt-ivory": "Linen Kris Shirt",
  "les-deux-linen-kris-ss-shirt-navy": "Linen Kris SS Shirt",
  "les-deux-linen-kris-ss-shirt-olive": "Linen Kris SS Shirt",
  "les-deux-linen-kris-ss-shirt-ivory": "Linen Kris SS Shirt",
  "les-deux-como-reg-chino-shorts-olive": "Como Chino Shorts",
  "les-deux-como-reg-chino-shorts-black": "Como Chino Shorts",
  "les-deux-como-reg-chino-shorts-navy": "Como Chino Shorts",
  "les-deux-langley-overshirt-olive": "Langley Overshirt",
  "les-deux-langley-overshirt-navy": "Langley Overshirt",
  "les-deux-ballier-track-shorts-sand": "Ballier Track Shorts",
  "les-deux-ballier-track-shorts-black": "Ballier Track Shorts",
  "les-deux-ballier-loose-track-pants-black": "Ballier Loose Pants",
  "les-deux-ballier-loose-track-pants-sand": "Ballier Loose Pants",
  "les-deux-half-zip-tracktop-ballier-black": "Ballier Half-Zip",
  "les-deux-ballier-tracktop-black": "Ballier Tracktop",
  "les-deux-encore-hoodie-walnut": "Encore Hoodie",
  "les-deux-curved-crew-tee-forrest": "Curved Crew Tee",
  "les-deux-blake-tee-white": "Blake Tee",
  "les-deux-leather-theodor-sneaker-white": "Theodor Sneaker",
  "lyle-scott-crew-sweat-charcoal": "Crew Sweat",
  "lyle-scott-crew-sweat-grey": "Crew Sweat",
  "lyle-scott-crew-sweat-olive": "Crew Sweat",
  "lyle-scott-crew-sweat-black": "Crew Sweat",
  "lyle-scott-logo-zip-hoodie-black": "Logo Zip Hoodie",
  "lyle-scott-logo-hoodie-olive": "Logo Hoodie",
  "lyle-scott-logo-hoodie-charcoal": "Logo Hoodie",
  "lyle-scott-logo-hoodie-black": "Logo Hoodie",
  "lyle-scott-logo-hoodie-navy": "Logo Hoodie",
  "lyle-scott-merino-crew-knit-charcoal": "Merino Crew Knit",
  "calvin-klein-trunks-3-pack-white": "Trunks 3-pack",
  "tommy-hilfiger-women-cotton-dress-1985-navy": "Cotton Dress 1985",
  "tommy-hilfiger-women-classic-down-jacket-1985-black": "Down Jacket 1985",
  "tommy-hilfiger-women-classic-down-vest-1985-black": "Classic Down Vest 1985",
  "tommy-hilfiger-women-polo-classic-1985-white": "Polo Classic 1985",
  "tommy-hilfiger-women-polo-classic-1985-black": "Polo Classic 1985",
  "under-armour-fill-logo-tee-black": "Fill Logo Tee",
  "tommy-hilfiger-women-essential-top-white": "Essential Top",
  "tommy-hilfiger-women-essential-top-beige": "Essential Top",
  "tommy-hilfiger-women-essential-top-black": "Essential Top",
  "tommy-hilfiger-women-suede-runner-white": "Suede Runner",
  "skechers-women-bobs-b-flex-sneakers-white": "Bobs B Flex Sneakers",
  "under-armour-tech-tee-shadow": "Tech Tee",
  "u-s-polo-assn-women-sweatpants-alice-navy": "Sweatpants Alice",
  "u-s-polo-assn-women-t-shirt-amy-white": "T-shirt Amy",
  "u-s-polo-assn-women-t-shirt-amy-ginger": "T-shirt Amy",
  "u-s-polo-assn-women-t-shirt-amy-navy": "T-shirt Amy",
  "u-s-polo-assn-women-t-shirt-amy-black": "T-shirt Amy",
  "u-s-polo-assn-women-hoodie-aba-navy": "Hoodie Aba",
  "u-s-polo-assn-women-hoodie-aba-black": "Hoodie Aba",
  "u-s-polo-assn-women-sweatshirt-adele-navy": "Sweatshirt Adele",
  "u-s-polo-assn-women-sweatshirt-adele-black": "Sweatshirt Adele",
  "u-s-polo-assn-women-sweatpants-alice-grey": "Sweatpants Alice",
  "u-s-polo-assn-women-sweatpants-alice-black": "Sweatpants Alice",
  "u-s-polo-assn-women-coat-birgitte-black": "Coat Birgitte",
  "u-s-polo-assn-women-hoodie-duru-port": "Duru Velour Hoodie",
  "u-s-polo-assn-women-hoodie-duru-black": "Velour Hoodie Duru",
  "u-s-polo-assn-women-sweatpants-dudi-port": "Dudi Velour Pants",
  "u-s-polo-assn-women-sweatpants-dudi-navy": "Velour Pants Dudi",
  "u-s-polo-assn-women-sweatpants-dudi-black": "Velour Pants Dudi",
  "u-s-polo-assn-women-hoodie-duru-navy": "Velour Hoodie Duru",
  "hugo-boss-jonah-runn-sneakers-black": "Jonah Runn Sneakers",
  "hugo-boss-jonah-trainers-mix-material-natural": "Jonah Trainers Mix",
  "hugo-boss-jonah-trainers-mix-material-black": "Jonah Trainers Mix",
  "adidas-aeroready-training-tee-navy": "Tee Aeroready",
  "adidas-aeroready-training-tee-white": "Tee Aeroready",
  "adidas-aeroready-training-tee-black": "Tee Aeroready",
  "adidas-aeroready-essential-polo-black": "Polo Aeroready",
  "adidas-aeroready-training-shorts-navy": "Aeroready Shorts",
  "u-s-polo-assn-t-shirt-arjun-forest": "T-shirt Arjun",
  "u-s-polo-assn-t-shirt-arjun-black": "T-shirt Arjun",
  "u-s-polo-assn-sweatpants-ashlar-black": "Sweatpants Ashlar",
  "u-s-polo-assn-half-zip-knit-brison-light": "Half-Zip Knit Brison",
  "nike-academy-winter-jacket-black": "Academy Winter Jacket",
  "hugo-boss-3-pack-v-neck-regular-t-shirt-white": "V-Neck 3-pack",
  "hugo-boss-knit-cashmere-blend-sort": "Knit Cashmere Blend",
  "hugo-boss-regular-denim-jeans-dark": "Jeans",
  "levis-chino-xx-shorts-navy": "Chino XX Shorts",
  "levis-chino-xx-shorts-army": "Chino XX Shorts",
  "resterods-cargo-light-pants-army": "Cargo Pants Light",
  "resterods-cargo-light-pants-black": "Cargo Pants Light",
  "jbs-6-pack-bamboo-boxers-black": "6-pack Bamboo Boxers",
  "jbs-2-pack-bamboo-t-shirt-v-neck-black": "2-pack V-Neck",
  "jbs-2-pack-bamboo-t-shirt-black": "2-Pack Bamboo T-shirt",
  "jbs-2-pack-bamboo-t-shirt-white": "2-Pack Bamboo T-shirt",
  "jbs-3-pack-organic-cotton-boxers-301": "3-pack Boxers",
  "jbs-3-pack-organic-cotton-boxers-black": "3-pack Boxers",
  "jbs-2-pack-organic-cotton-t-shirt-v-neck-black": "2-pack V-Neck Tee",
  "jbs-2-pack-organic-cotton-t-shirt-black": "2-Pack Organic Tee",
  "jbs-2-pack-organic-cotton-t-shirt-white": "2-Pack Organic Tee",
  "u-s-polo-assn-2-pack-t-shirt-cloud-navy": "2-Pack T-shirt Cloud",
  "u-s-polo-assn-3-pack-abadalla-trunks-navy": "3-pack Trunks",
  "u-s-polo-assn-half-zip-sweatshirt-faik-grey": "Half-Zip Sweat Faik",
  "u-s-polo-assn-sweatshirt-adler-navy": "Sweatshirt Adler",
  "u-s-polo-assn-shirt-flex-calvert-blue": "Shirt Flex Calvert",
  "u-s-polo-assn-polo-alfred-navy": "Polo Alfred",
  "u-s-polo-assn-polo-alfred-forest": "Polo Alfred",
  "u-s-polo-assn-polo-alfred-white": "Polo Alfred",
  "tommy-hilfiger-women-slides-logo-gold": "Slides Logo",
  "tommy-hilfiger-women-leather-cupsole-tjm-sneaker-white": "Cupsole TJM",
  "u-s-polo-assn-half-zip-sweatshirt-faik-navy": "Half-Zip Sweat Faik",
  "u-s-polo-assn-linen-shirt-bolt-sand": "Linen Shirt Bolt",
  "u-s-polo-assn-shirt-armin-navy": "Oxford Shirt Armin",
  "u-s-polo-assn-knit-sweater-adair-black": "Knit Adair",
  "resterods-lightweight-nylon-pants-black": "Light Nylon Pants",
  "resterods-1-4-zip-fleece-pullover-black": "1/4 Zip Fleece Pullover",
  "u-s-polo-assn-sweatpants-ashlar-forest": "Sweatpants Ashlar",
  "u-s-polo-assn-sweatpants-ashlar-navy": "Sweatpants Ashlar",
  "u-s-polo-assn-full-zip-sweatshirt-eran-navy": "Zip Sweatshirt Eran",
  "u-s-polo-assn-shirt-flex-calvert-dark": "Shirt Flex Calvert",
  "u-s-polo-assn-shirt-flex-calvert-rubber": "Calvert Flex Shirt",
  "u-s-polo-assn-shirt-craig-denim-dark": "Shirt Craig Denim",
  "u-s-polo-assn-half-zip-knit-brison-navy": "Half-Zip Knit Brison",
  "u-s-polo-assn-shirt-armin-white": "Oxford Shirt Armin",
  "u-s-polo-assn-shirt-flex-calvert-army": "Shirt Flex Calvert",
  "u-s-polo-assn-knit-sweater-adair-navy": "Knit Adair",
  "u-s-polo-assn-knit-sweater-adair-forest": "Knit Adair",
  "u-s-polo-assn-sweatshirt-adler-grey": "Sweatshirt Adler",
  "u-s-polo-assn-sweatshirt-adler-black": "Sweatshirt Adler",
  "u-s-polo-assn-polo-alfred-black": "Polo Alfred",
  "u-s-polo-assn-hoodie-brayden-grey": "Hoodie Brayden",
  "u-s-polo-assn-t-shirt-arjun-white": "T-shirt Arjun",
  "u-s-polo-assn-t-shirt-arjun-navy": "T-shirt Arjun",
  "hugo-boss-women-pyjamas-pants-soft-cotton-white": "Pyjamas Pants Soft",
  "hugo-boss-women-pyjamas-pants-soft-cotton-black": "Pyjamas Pants Soft",
  "hugo-boss-women-pyjamas-t-shirt-soft-cotton-black": "Pyjamas Tee",
  "hugo-boss-women-pyjamas-t-shirt-soft-cotton-white": "Pyjamas Tee",
  "hugo-boss-1-4-zip-knit-regular-sweatshirt-black": "1/4 Zip Knit Sweatshirt",
  "peak-performance-down-frost-jacket-olive": "Down Frost Jacket",
  "under-armour-shorts-tech-black": "Tech Shorts",
  "ralph-lauren-master-suede-sneaker-black": "Master Suede Sneaker",
  "ralph-lauren-leather-chelsea-boots-brown": "Leather Chelsea Boots",
  "timberland-archive-puffer-jacket-black": "Archive Puffer Jacket",
  "ralph-lauren-leather-chealsea-boots-black": "Leather Chelsea Boots",
  "timberland-logo-gloves-black": "Logo Gloves",
  "lacoste-women-logo-sweatshirt-grey": "Logo Sweatshirt",
  "lacoste-women-logo-hoodie-black": "Logo Hoodie",
  "lacoste-women-pyjamas-set-logo-black": "Pyjamas Set Logo",
  "armani-ea7-control-high-sneaker-black": "Control High",
  "armani-ea7-no-lace-logo-sneaker-black": "EA7 No-Lace Sneaker",
  "armani-ea7-neck-gaiter-black": "EA7 Neck Gaiter",
  "armani-ea7-wool-gloves-black": "EA7 Wool Gloves",
  "armani-ea7-hooded-down-jacket-black": "EA7 Down Jacket",
  "armani-ea7-pants-tape-logo-gold-1": "EA7 Pants Tape Logo",
  "hugo-boss-contrast-paddy-polo-012": "Contrast Paddy Polo",
  "hugo-boss-paddy-pro-contrast-polo-night": "Paddy Pro Polo",
  "hugo-boss-knit-cashmere-blend-kesom-black": "Kesom Cashmere Knit",
  "hugo-boss-knit-cashmere-blend-grey": "Knit Cashmere Blend",
  "les-deux-boucle-sweatshirt-black": "Bouclé Sweatshirt",
  "les-deux-boucle-hoodie-black": "Bouclé Hoodie",
  "armani-ea7-core-id-polo-shirt-olive": "EA7 Core ID Polo Shirt",
  "armani-ea7-core-id-l-s-tee-olive": "EA7 Core ID L/S Tee",
  "armani-ea7-trainers-high-rise-logo-black": "EA7 Trainer High",
  "hugo-boss-paddy-pro-contrast-polo-405": "Paddy Pro Polo",
  "lacoste-women-logo-tee-velour-black": "Logo Tee Velour",
  "lacoste-women-logo-line-thong-black": "Logo Line Thong",
  "lacoste-women-logo-line-briefs-black": "Logo Line Briefs",
  "lacoste-leather-lineshot-trainers-black": "Lineshot Trainer",
  "lacoste-leather-street-sneakers-white": "Street Sneaker",
  "lacoste-leather-street-sneakers-black": "Street Sneaker",
  "lacoste-joggers-fleece-blend-navy": "Joggers Fleece Blend",
  "lacoste-classic-tracksuit-grey": "Tracksuit Regular Fit",
  "lacoste-l-s-tee-essential-logo-black": "L/S Tee Essential Logo",
  "lacoste-hoodie-organic-cotton-grass": "Hoodie Organic",
  "armani-ea7-piumino-jacket-hooded-black": "EA7 Piumino Jacket",
  "armani-ea7-core-id-s-s-tee-light": "EA7 Core ID S/S Tee",
  "ralph-lauren-heritage-suede-court-sneaker-black": "Heritage Court",
  "ralph-lauren-master-court-sneaker-black": "Master Court Sneaker",
  "ralph-lauren-1-4-zip-logo-pullover-grey": "1/4 Zip Logo Pullover",
  "timberland-polartec-1-4-zip-fleece-black": "Polartec 1/4 Zip Fleece",
  "timberland-colour-block-fleece-neck-gaiter-black": "Neck Gaiter",
  "timberland-basic-l-s-polo-black": "Basic L/S Polo",
  "timberland-kennebec-tee-black": "Kennebec Tee",
  "timberland-organic-l-s-tee-black": "Organic L/S Tee",
  "timberland-zip-hood-basic-logo-black": "Zip Hood Basic Logo",
  "timberland-half-zip-cotton-knit-black": "Half Zip Cotton Knit",
  "timberland-crew-sweat-wwes-black": "Crew Sweat WWES",
  "timberland-basic-polo-black": "Basic Polo",
  "timberland-organic-s-s-tee-leaf": "Organic S/S Tee",
  "timberland-basic-crew-sweatshirt-black": "Basic Crew Sweatshirt",
  "timberland-organic-s-s-tee-navy": "Organic S/S Tee",
  "hugo-boss-patch-wetalk-logo-hoodie-khaki": "Wetalk Logo Hoodie",
  "hugo-boss-patch-wetalk-logo-hoodie-indigo": "Wetalk Logo Hoodie",
  "hugo-boss-suede-runn-trainers-black": "Suede Runn Trainers",
  "hugo-boss-knit-regular-blend-black": "Knit Regular",
  "ralph-lauren-suede-trainers-white": "Suede Trainers",
  "ralph-lauren-double-knit-zip-hoodie-grey": "Double Knit Zip Hoodie",
  "peak-performance-essential-logo-hoodie-navy": "Original Hood",
  "peak-performance-essential-logo-hoodie-black": "Original Hood",
  "peak-performance-essential-logo-hoodie-white": "Original Hood",
  "peak-performance-essential-logo-sweatshirt-black": "Original Crew",
  "peak-performance-essential-logo-sweatshirt-grey": "Original Crew",
  "hugo-boss-contrast-paddy-polo-morkebla": "Contrast Paddy Polo",
  "hugo-boss-contrast-paddy-polo-sort": "Contrast Paddy Polo",
  "bjorn-borg-boxers-5-pack-black": "Boxers 5-Pack",
  "armani-eagle-boxers-3-pack-white": "Eagle Trunks 3-pack",
  "lacoste-hoodie-organic-cotton-green": "Hoodie Organic",
  "lacoste-regular-s-s-polo-pike-sand": "Classic Polo Piké",
  "armani-ea7-eagle-front-logo-sneakers-jet": "EA7 Eagle Sneakers",
  "armani-ea7-leather-sneakers-black": "EA7 Leather Sneakers",
  "armani-ea7-leather-sneakers-white": "EA7 Leather Sneakers",
  "gant-relaxed-chino-shorts-black": "Relaxed Chino Shorts",
  "gant-relaxed-chino-shorts-army": "Relaxed Chino Shorts",
  "gant-relaxed-chino-shorts-khaki": "Relaxed Chino Shorts",
  "tommy-hilfiger-women-bikini-bralette-navy": "Bikini Bralette",
  "tommy-hilfiger-women-cheeky-bikini-bottom-navy": "Cheeky Bikini Bottom",
  "tommy-hilfiger-women-side-tie-cheeky-bikini-bottom-red": "Side-Tie Bikini",
  "hugo-boss-paddy-pro-contrast-polo-sort": "Paddy Pro Polo",
  "hugo-boss-big-contrast-logo-tee-navy": "Big Contrast Logo Tee",
  "hugo-boss-big-contrast-logo-tee-black": "Big Contrast Logo Tee",
  "under-armour-tech-shorts-navyblue": "Tech Shorts",
  "under-armour-fleece-1-4-zip-black": "Fleece 1/4 Zip",
  "under-armour-cotton-shorts-black": "Cotton Shorts",
  "under-armour-tech-2-0-polo-navy": "Tech 2.0 Polo",
  "tommy-hilfiger-women-bikini-bralette-red": "Bikini Bralette",
  "tommy-hilfiger-women-brazilian-bikini-bottom-red": "Brazilian Bikini Bottom",
  "tommy-hilfiger-women-one-piece-swimsuit-red": "One-Piece Swimsuit",
  "ralph-lauren-slim-fit-polo-green": "Slim Fit Polo",
  "ralph-lauren-slim-fit-polo-grey": "Slim Fit Polo",
  "tommy-hilfiger-women-one-piece-swimsuit-navy": "One-Piece Swimsuit",
  "tommy-hilfiger-women-brazilian-bikini-bottom-navy": "Brazilian Bikini Bottom",
  "tommy-hilfiger-women-hwk-hoody-grey": "HWK Hoodie",
  "tommy-hilfiger-womens-leggings-grey": "Leggings Side Logo",
  "tommy-hilfiger-women-thong-3-pack-essential-black": "Thong 3-pack Essential",
  "tommy-hilfiger-women-bikini-briefs-3-pack-essential-black": "Bikini Briefs 3-pack",
  "tommy-hilfiger-women-bikini-briefs-3-pack-essential-multi": "Bikini Briefs 3-pack",
  "les-deux-2-pack-boxers-warren-black": "2-Pack Boxers Warren",
  "les-deux-norregaard-hoodie-black": "Nørregaard Hoodie",
  "dsquared2-blue-cool-guy-denim-jeans": "Blue Cool Guy Jeans",
  "dsquared2-skater-denim-jeans-navy": "Skater Denim Jeans",
  "dsquared2-navy-cool-guy-denim-jeans": "Navy Cool Guy Jeans",
  "dsquared2-black-cool-guy-denim-jeans": "Black Cool Guy Jeans",
  "dsquared2-surf-board-logo-tee-black": "Surf Board Logo Tee",
  "ralph-lauren-slim-oxford-short-sleeve-shirt-white": "Oxford S/S Shirt",
  "les-deux-oxford-kristian-shirt-black": "Oxford Kristian Shirt",
  "ralph-lauren-hanford-sneaker-grey1": "Hanford Sneaker",
  "lacoste-regular-s-s-logo-tee-grass": "Regular Logo Tee",
  "lacoste-l004-low-sneakers-black": "L004 Low Sneakers",
  "lacoste-regular-s-s-polo-pike-turquoise": "Classic Polo Piké",
  "lacoste-regular-s-s-polo-pike-pale": "Classic Polo Piké Pale",
  "gant-2-pack-v-neck-tee-regular-fit-black": "2-Pack V-Neck Tee",
  "gant-2-pack-tee-regular-fit-111": "2-Pack Tee Regular Fit",
  "gant-2-pack-tee-regular-fit-black": "2-Pack Tee Regular Fit",
  "hugo-boss-contrast-shorts-black": "Swim Shorts Quick-Dry",
  "hugo-boss-3-pack-regular-t-shirt-black": "3-pack T-shirt",
  "ralph-lauren-tee-print-logo-white": "Tee Print Logo",
  "ralph-lauren-dot-signature-tee-black": "Dot Signature Tee",
  "lyle-scott-regular-tee-olive": "T-shirt",
  "lyle-scott-regular-polo-shirt-olive": "Polo Shirt",
  "gant-basic-s-s-tee-blue": "Basic S/S Tee",
  "gant-shield-s-s-logo-regular-tee-white": "Shield Logo T-shirt",
  "hugo-boss-velour-sweatshirt-gold": "Velour Sweatshirt",
  "hugo-boss-velour-pants-gold": "Velour Pants",
  "hugo-boss-pelogox-polo-navy": "Pelogox Polo",
  "hugo-boss-pelogox-polo-black": "Pelogox Polo",
  "hugo-boss-j_phlox-jacket-black": "J_Phlox Jacket",
  "hugo-boss-3-pack-v-neck-regular-t-shirt-black": "V-Neck 3-pack",
  "armani-ea7-side-logo-swim-shorts-grey": "EA7 Side Swim",
  "armani-ea7-bomber-jacket-oyster": "EA7 Zip Up Jacket",
  "gant-broad-shirt-short-sleeve-navy": "Broad Shirt S/S",
  "armani-ea7-slides-d467": "EA7 Slides",
  "armani-ea7-side-logo-swim-shorts-navy": "EA7 Side Swim",
  "armani-ea7-side-logo-swim-shorts-gold": "EA7 Side Swim",
  "armani-ea7-side-logo-swim-shorts-black": "EA7 Side Swim",
  "lacoste-regular-s-s-polo-pike-lemon": "Classic Polo Piké",
  "lacoste-regular-s-s-logo-tee-sand": "Regular Logo Tee",
  "ralph-lauren-featherweight-shirt-black": "Featherweight Shirt",
  "calvin-klein-3-pack-briefs-xwb": "3-pack Briefs XWB",
  "gant-women-jacket-down-puffer-black": "Jacket Down Puffer",
  "gant-long-jacket-alta-down-black": "Long Jacket Alta Down",
  "gant-women-l-s-logo-polo-navy": "L/S Logo Polo",
  "gant-tamaware-gold-shield-slippers-black": "Tamaware Slippers",
  "gant-women-shield-logo-hoodie-navy": "Shield Logo Hoodie",
  "gant-women-shield-logo-hoodie-black": "Shield Logo Hoodie",
  "gant-joree-leather-sneakers-black": "Joree Sneaker",
  "gant-fairwyn-boots-suede-black": "Fairwyn Suede Boots",
  "gant-l-s-gold-shield-pique-polo-regular-black": "Gold Shield L/S Polo",
  "gant-regular-broadcloth-shirt-black": "Broadcloth Shirt",
  "gant-suede-sneakers-carst-black": "Suede Sneakers",
  "lacoste-logo-knit-gloves-black": "Wool Knit Gloves",
  "lacoste-sweatpants-organic-logo-grey": "Sweatpants Organic",
  "lacoste-sweatpants-organic-logo-black": "Sweatpants Organic",
  "lacoste-organic-logo-hoodie-grey": "Hoodie Organic",
  "lacoste-organic-logo-hoodie-navy": "Hoodie Organic",
  "lacoste-organic-logo-hoodie-white": "Hoodie Organic",
  "lacoste-organic-logo-hoodie-black": "Hoodie Organic",
  "lacoste-full-zip-logo-track-top-black": "Zip Logo Track Top",
  "lacoste-trunks-3-pack-multi": "Trunks 3-pack",
  "lacoste-trunks-3-pack-black": "Trunks 3-pack",
  "lacoste-high-turtleneck-logo-navy": "High Turtleneck Logo",
  "lacoste-3-pack-v-neck-tee-plain-cotton-black": "3-pack V-Neck Tee",
  "lacoste-3-pack-crew-tee-plain-cotton-black": "3-pack Crew Tee",
  "lacoste-joggers-fleece-blend-black": "Joggers Fleece Blend",
  "lacoste-joggers-fleece-blend-grey": "Joggers Fleece Blend",
  "lacoste-premium-pima-l-s-logo-tee-black": "Pima L/S Tee",
  "lacoste-premium-pima-l-s-logo-tee-navy": "Pima L/S Tee",
  "hugo-boss-women-tonal-logo-bralette-2-pack-black": "2-pack Bralette",
  "resterods-bamboo-sweatpants-sand": "Bamboo Sweatpants",
  "levis-original-logo-l-s-tee-black": "Original Logo L/S Tee",
  "levis-2-pack-tee-housemark-logo-grey-white": "2-Pack Tee Housemark",
  "levis-2-pack-tee-graphic-logo-white-black": "2-Pack Tee Graphic",
  "levis-graphic-logo-l-s-tee-black": "Graphic Logo L/S Tee",
  "levis-graphic-logo-hoodie-olive": "Graphic Logo Hoodie",
  "levis-graphic-logo-hoodie-grey": "Graphic Logo Hoodie",
  "levis-graphic-logo-hoodie-black": "Graphic Logo Hoodie",
  "levis-new-original-sweatshirt-black": "New Original Sweat",
  "levis-new-original-sweatshirt-navy": "New Original Sweat",
  "levis-new-original-sweatshirt-grey": "New Original Sweat",
  "levis-new-original-hoodie-navy": "New Original Hoodie",
  "levis-new-original-hoodie-grey": "New Original Hoodie",
  "levis-new-original-hoodie-black": "New Original Hoodie",
  "tommy-hilfiger-women-essential-plaque-high-heels-black": "Plaque High Heels",
  "hugo-boss-3-pack-v-neck-regular-t-shirt-blue": "V-Neck 3-pack",
  "hugo-boss-patch-wetalk-logo-hoodie-open": "Wetalk Logo Hoodie",
  "hugo-boss-women-tonal-logo-thong-3-pack-black": "Tonal Thong 3-pack",
  "hugo-boss-women-logo-thong-3-pack-black": "Logo Thong 3-pack",
  "hugo-boss-women-logo-bralette-2-pack-white": "Logo Bralette 2-Pack",
  "hugo-boss-women-logo-bralette-2-pack-red": "Logo Bralette 2-Pack",
  "hugo-boss-women-logo-bralette-2-pack-black": "Logo Bralette 2-Pack",
  "tommy-hilfiger-women-organic-tee-grey": "Organic Tee",
  "tommy-hilfiger-women-organic-tee-black": "Organic Tee",
  "tommy-hilfiger-women-organic-tee-white": "Organic Tee",
  "tommy-hilfiger-women-organic-tee-navy": "Organic Tee",
  "ralph-lauren-longwood-leather-sneaker-blackout": "Longwood Sneaker",
  "ralph-lauren-sayer-suede-sneaker-green": "Sayer Suede Sneaker",
  "ralph-lauren-3-pack-s-s-tee-black": "3-pack S/S Tee",
  "ralph-lauren-cuffed-pants-black": "Cuffed Pants",
  "ralph-lauren-cuffed-pants-navy": "Cuffed Pants",
  "ralph-lauren-cable-knit-pullover-black": "Cable Knit Pullover",
  "ralph-lauren-fleece-knit-hoodie-navy": "Fleece Knit Hoodie",
  "ralph-lauren-crew-neck-sweatshirt-navy": "Crew Neck Sweatshirt",
  "ralph-lauren-crew-neck-sweatshirt-black": "Crew Neck Sweatshirt",
  "ralph-lauren-custom-slim-fit-polo-washed": "Custom Slim Polo",
  "ralph-lauren-1-4-zip-logo-pullover-black": "1/4 Zip Logo Pullover",
  "gant-women-tonal-logo-knit-navy": "Lambswool Knit",
  "gant-women-high-neck-cable-knit-navy": "High Neck Cable Knit",
  "gant-women-high-neck-cable-knit-green": "High Neck Cable Knit",
  "gant-women-cable-knit-navy": "Cable Knit",
  "gant-women-gold-shield-sweatpants-green": "Shield Sweatpants",
  "gant-women-gold-shield-sweatpants-black": "Shield Sweatpants",
  "gant-women-gold-shield-hoodie-green": "Gold Shield Hoodie",
  "gant-women-gold-shield-hoodie-black": "Gold Shield Hoodie",
  "gant-women-shield-logo-hoodie-putty": "Shield Logo Hoodie",
  "gant-women-crest-logo-sweatpants-black": "Crest Logo Sweatpants",
  "gant-women-crest-logo-sweatshirt-black": "Crest Logo Sweatshirt",
  "gant-women-turtleneck-black": "Turtleneck",
  "gant-oxford-regular-shirt-white": "Oxford Shirt",
  "gant-gold-shield-sweatpants-navy": "Shield Sweatpants",
  "gant-gold-shield-hoodie-antracit": "Gold Shield Hoodie",
  "gant-gold-shield-crew-sweatshirt-antracit": "Shield Crew Sweat",
  "gant-zip-hoodie-black": "Zip Hoodie",
  "gant-slim-pique-l-s-tee-black": "Slim Pique L/S Tee",
  "gant-shield-s-s-logo-regular-tee-navy": "Shield Logo T-shirt",
  "gant-shield-s-s-logo-regular-tee-black": "Shield Logo T-shirt",
  "armani-ea7-runner-sneakers-black-silver": "EA7 Silver Runner",
  "armani-ea7-low-logo-sneakers-blackout": "EA7 Leather Sneakers",
  "armani-ea7-eagle-triple-trainers-black": "EA7 Eagle Triple",
  "armani-ea7-classic-low-sneakers-blackout": "EA7 Sneaker",
  "calvin-klein-sleepwear-pants-black": "Sleepwear Pants",
  "puma-women-chill-tank-top-black": "Chill Tank Top",
  "puma-women-fleece-zip-hoodie-black": "Fleece Zip Hoodie",
  "puma-women-fleece-zip-hoodie-pink": "Fleece Zip Hoodie",
  "puma-women-training-tights-logo-grey": "Training Tights Logo",
  "puma-women-tracksuit-logo-black": "Tracksuit Logo",
  "puma-women-flyer-flex-running-sneaker-pink": "Flyer Flex Sneaker",
  "puma-women-flyer-flex-running-sneaker-multi": "Flyer Flex Sneaker",
  "puma-women-flyer-flex-running-sneaker-black": "Flyer Flex Sneaker",
  "puma-women-performance-logo-tee-black": "Performance Logo Tee",
  "puma-women-dry-shorts-logo-black": "Dry Shorts Logo",
  "puma-women-performance-logo-tee-turquoise": "Performance Logo Tee",
  "puma-women-performance-logo-tee-pink": "Performance Logo Tee",
  "puma-women-studio-shorts-foundation": "Studio Shorts",
  "puma-women-studio-shorts-black": "Studio Shorts",
  "puma-women-essential-logo-hoodie-grey": "Essential Logo Hoodie",
  "puma-women-tape-sweatpants-logo-rose": "Tape Sweatpants Logo",
  "puma-women-tape-sweatpants-logo-black": "Tape Sweatpants Logo",
  "armani-ea7-tracksuit-graphic-marine": "EA7 Tracksuit Graphic",
  "armani-ea7-id-logo-zip-hoodie-gold": "EA7 ID Logo Zip Hoodie",
  "armani-ea7-sweatshirt-graphic-marine": "EA7 Sweatshirt Graphic",
  "armani-ea7-transitional-jacket-black": "EA7 Transitional Jacket",
  "hugo-boss-5-pack-stretch-cotton-trunks-multi": "5-pack Trunks",
  "armani-ea7-runner-sneakers-black-gold": "EA7 Gold Runner",
  "hugo-boss-l-s-tee-curved-logo-black": "L/S Tee Curved Logo",
  "hugo-boss-salbo-iconic-sweatshirt-black": "Salbo Iconic Sweat",
  "levis-housemark-graphic-tee-navy": "Graphic Tee",
  "levis-housemark-graphic-tee-grey": "Graphic Tee",
  "levis-housemark-graphic-tee-black": "Graphic Tee",
  "armani-ea7-zip-hoodie-graphic-black": "EA7 Zip Hoodie Graphic",
  "nike-academy-dri-fit-pants-navy": "Academy Dri-FIT Pants",
  "nike-women-dri-fit-1-4-zip-academy-black": "Dri-FIT 1/4 Zip Academy",
  "nike-women-dri-fit-tee-academy-white": "Dri-FIT Tee Academy",
  "nike-women-air-max-ap-sneakers-black": "Air Max AP Sneakers",
  "nike-park-track-pants-black": "Park Track Pants",
  "armani-ea7-core-l-s-polo-gold": "EA7 Core L/S Polo",
  "armani-ea7-core-id-track-pants-gold": "EA7 Core ID Track Pants",
  "hugo-boss-patch-wetalk-logo-hoodie-pearly": "Wetalk Logo Hoodie",
  "lyle-scott-swim-shorts-navy": "Swim Shorts",
  "lyle-scott-swim-shorts-black": "Swim Shorts",
  "ralph-lauren-chambray-denim-shirt-washed-blue": "Chambray Denim Shirt",
  "ralph-lauren-slim-fit-polo-washed": "Slim Fit Polo Washed",
  "hugo-boss-paule-2-polo-black": "Paule 2 Polo",
  "armani-ea7-core-id-l-s-tee-gold": "EA7 Core ID L/S Tee",
  "armani-ea7-id-logo-hoodie-gold": "EA7 ID Logo Hoodie",
  "lyle-scott-oxford-shirt-regular-navy": "Oxford Shirt Regular",
  "lyle-scott-oxford-shirt-regular-black": "Oxford Shirt Regular",
  "lyle-scott-oxford-shirt-regular-white": "Oxford Shirt Regular",
  "lyle-scott-pipe-sweatshirt-black": "Pipe Sweatshirt",
  "lyle-scott-pipe-hoodie-black": "Pipe Hoodie",
  "lyle-scott-logo-cotton-shorts-black": "Logo Cotton Shorts",
  "lyle-scott-regular-polo-shirt-darkgreen": "Polo Shirt",
  "lyle-scott-pipe-sweatpants-black": "Pipe Sweatpants",
  "lyle-scott-regular-tee-darkgreen": "T-shirt",
  "lyle-scott-regular-tee-mist": "T-shirt Light Mist",
  "lyle-scott-regular-tee-bordeaux": "T-shirt Dark",
  "lacoste-sport-tape-polo-black": "Sport Tape Polo",
  "lacoste-women-logo-bikini-swimsuit-black": "Logo Bikini Swimsuit",
  "lacoste-women-bikini-bottom-red": "Bikini Bottom",
  "lacoste-s-s-regular-shirt-sky": "S/S Shirt",
  "nike-women-7-8-leggings-swoosh-logo-grey": "Swoosh Leggings",
  "nike-women-7-8-leggings-swoosh-logo-black": "Swoosh Leggings",
  "lacoste-knitted-pullover-grey": "Knit Pullover",
  "lacoste-women-gold-logo-low-sneakers-black": "Gold Low Sneaker",
  "lacoste-women-lerond-sneaker-white": "Lerond Sneaker",
  "nike-women-downshifter-11-trainers-white": "Downshifter 11",
  "nike-court-tee-heritage-logo-white": "Court Tee Heritage",
  "adidas-women-sweatpants-black": "Sweatpants",
  "adidas-women-sweatpants-navy": "Sweatpants",
  "adidas-women-training-pants-navy": "Training Pants",
  "adidas-women-training-pants-black": "Training Pants",
  "adidas-women-logo-shorts-arctic": "Logo Shorts",
  "adidas-women-logo-shorts-white": "Logo Shorts",
  "adidas-women-logo-shorts-navy": "Logo Shorts",
  "adidas-women-logo-shorts-black": "Logo Shorts",
  "adidas-women-training-jacket-red": "Training Jacket",
  "adidas-women-training-jacket-navy": "Training Jacket",
  "adidas-women-training-jacket-white": "Training Jacket",
  "adidas-women-training-jacket-black": "Training Jacket",
  "adidas-women-training-tee-red": "Training Tee",
  "adidas-women-training-tee-black": "Training Tee",
  "adidas-women-training-tee-white": "Training Tee",
  "wood-wood-aa-circle-logo-tee-white": "AA Circle Logo Tee",
  "adidas-women-logo-hoodie-red": "Logo Hoodie",
  "adidas-women-logo-hoodie-navy": "Logo Hoodie",
  "wood-wood-aa-sweatshirt-navy": "AA Sweatshirt",
  "wood-wood-aa-hoodie-navy": "AA Hoodie",
  "wood-wood-aa-circle-logo-l-s-tee-white": "AA Circle Logo L/S Tee",
  "wood-wood-double-a-patch-l-s-tee-navy": "Double A Patch L/S Tee",
  "wood-wood-aa-longsleeve-tee-blue": "AA Longsleeve Tee",
  "puma-women-caven-sneaker-white": "Caven Sneaker",
  "puma-women-voyage-trainer-grey": "Voyage Trainer",
  "puma-women-voyage-trainer-black": "Voyage Trainer",
  "puma-women-karmen-sneaker-black": "Karmen Sneaker",
  "puma-women-training-7-8-tights-black": "Training 7/8 Tights",
  "puma-women-essential-logo-tee-pink": "Essential Logo Tee",
  "puma-women-essential-logo-tee-black": "Essential Logo Tee",
  "puma-women-essential-logo-hoodie-black": "Essential Logo Hoodie",
  "puma-women-essential-logo-hoodie-pink": "Essential Logo Hoodie",
  "puma-women-cotton-shorts-logo-black": "Cotton Shorts Logo",
  "puma-women-training-logo-tights-black": "Training Tights Logo",
  "puma-women-logo-sweatpants-black": "Sweatpants Logo",
  "puma-women-training-tights-black": "Training Tights",
  "adidas-tiro-performance-pants-navy": "Tiro Pants",
  "adidas-logo-sweatshirt-black-1": "Logo Sweatshirt",
  "ralph-lauren-pyjamas-pants-navy": "Pyjamas Pants",
  "ralph-lauren-pyjamas-pants-black": "Pyjamas Pants",
  "les-deux-oxford-christoph-shirt-grey": "Christoph Oxford",
  "les-deux-oxford-christoph-shirt-blue": "Christoph Oxford",
  "les-deux-oxford-christoph-shirt-stripe": "Christoph Stripe",
  "gant-women-pique-dress-black": "Pique Dress",
  "gant-women-shield-logo-polo-rose": "Shield Logo Polo",
  "gant-women-shield-logo-polo-navy": "Shield Logo Polo",
  "gant-no-show-socks-2-pack-eggshell": "2-Pack No-Show Socks",
  "gant-women-gold-shield-sweatpants-navy": "Shield Sweatpants",
  "gant-women-gold-shield-zip-hoodie-navy": "Gold Shield Zip Hoodie",
  "gant-women-wash-bag-icon-rope-navy": "Wash Bag Icon Rope",
  "gant-women-gold-shield-crew-sweatshirt-navy": "Shield Crew Sweat",
  "gant-women-original-logo-tee-rose": "Original Logo Tee",
  "gant-women-original-logo-tee-pink": "Original Logo Tee",
  "gant-women-original-logo-tee-black": "Original Logo Tee",
  "gant-women-original-logo-tee-navy": "Original Logo Tee",
  "gant-women-original-logo-tee-white": "Original Logo Tee",
  "gant-women-gold-shield-logo-tee-white": "Gold Shield Logo Tee",
  "peak-performance-essential-logo-sweatshirt-navy": "Original Crew",
  "peak-performance-women-essential-logo-tee-grey": "Essential Logo Tee",
  "peak-performance-women-essential-logo-tee-white": "Essential Logo Tee",
  "peak-performance-l-s-tee-backprint-black": "L/S Tee Backprint",
  "peak-performance-women-essential-logo-tee-navy": "Essential Logo Tee",
  "peak-performance-women-essential-logo-tee-black": "Essential Logo Tee",
  "peak-performance-women-essential-logo-sweatshirt-navy": "Essential Sweat",
  "peak-performance-essential-logo-polo-black": "Essential Logo Polo",
  "peak-performance-women-essential-logo-hoodie-navy": "Essential Logo Hoodie",
  "les-deux-manuel-jacket-black": "Manuel Jacket",
  "les-deux-pique-polo-navy": "Piqué Polo",
  "ralph-lauren-l-s-tee-liquid-logo-white": "L/S Tee Liquid Logo",
  "ralph-lauren-l-s-tee-liquid-logo-black": "L/S Tee Liquid Logo",
  "ralph-lauren-3-pack-s-s-tee-multi": "3-pack S/S Tee",
  "ralph-lauren-soft-touch-tee-navy": "Soft-Touch Tee",
  "gant-swim-shorts-side-logo-marine": "Swim Shorts Side Logo",
  "gant-swim-shorts-side-logo-black": "Swim Shorts Side Logo",
  "gant-5-pack-trunks-cotton-stretch-navy": "5-Pack Trunks",
  "gant-5-pack-trunks-cotton-stretch-black": "5-Pack Trunks",
  "gant-gold-shield-s-s-logo-tee-antracit": "Gold Shield T-shirt",
  "gant-gold-shield-s-s-logo-tee-racing": "Gold Shield T-shirt",
  "gant-gold-shield-s-s-logo-tee-white": "Gold Shield T-shirt",
  "gant-gold-shield-s-s-logo-tee-navy": "Gold Shield T-shirt",
  "gant-gold-shield-s-s-logo-tee-grey": "Gold Shield T-shirt",
  "gant-gold-shield-s-s-logo-tee-black": "Gold Shield T-shirt",
  "gant-gold-shield-pique-polo-regular-white": "Gold Shield Polo",
  "armani-women-logo-tee-chest-white": "Logo Tee Chest",
  "armani-women-logo-tee-chest-black": "Logo Tee Chest",
  "armani-women-padded-bra-white": "Padded Bra",
  "armani-women-2-pack-brazilian-iconic-cotton-black-black": "2-pack Brazilian",
  "armani-women-2-pack-brazilian-iconic-cotton-black-white": "2-pack Brazilian",
  "armani-women-2-pack-brief-iconic-cotton-black-black": "2-Pack Brief Iconic",
  "armani-women-2-pack-brief-iconic-cotton-black-white": "2-Pack Brief Iconic",
  "armani-women-2-pack-brazilian-black-black": "2-Pack Brazilian",
  "armani-women-2-pack-brief-black-black": "2-Pack Brief",
  "armani-eagle-boxers-3-pack-black": "Eagle Trunks 3-pack",
  "tommy-hilfiger-women-polo-slim-crystal-logo-white": "Crystal TH Logo Polo",
  "tommy-hilfiger-women-polo-slim-crystal-logo-navy": "Crystal TH Logo Polo",
  "tommy-hilfiger-women-jacket-two-tone-glossy-navy": "Two Tone Jacket",
  "tommy-hilfiger-women-tee-floral-print-black": "Tee Floral Print",
  "tommy-hilfiger-women-puffer-vest-black": "Puffer Vest",
  "tommy-hilfiger-women-blouse-metallic-black": "Blouse Metallic",
  "tommy-hilfiger-women-high-rise-flex-jeans": "High Rise Flex Jeans",
  "tommy-hilfiger-women-logo-sweatshirt-est-1985-navy": "Sweat Est. 1985",
  "tommy-hilfiger-women-dress-drawstring-stripe": "Stripe Dress",
  "tommy-hilfiger-women-signature-bikini-bottom-navy": "Bikini Bottom",
  "tommy-hilfiger-women-3-pack-thong-pastel": "3-pack Thong",
  "tommy-hilfiger-women-5-pack-thong-multi": "5-Pack Thong",
  "tommy-hilfiger-women-v-neck-2-pack-tee-regular-fit-oxw": "V-Neck 2-pack Tee",
  "tommy-hilfiger-women-side-signature-bikini-bottom-navy": "Bikini Bottom",
  "tommy-hilfiger-women-bandeau-bikini-top-navy": "Bandeau Bikini Top",
  "tommy-hilfiger-women-triangle-bikini-top-navy-1": "Triangle Bikini Top",
  "tommy-hilfiger-women-push-up-bikini-top-navy": "Push-Up Bikini Top",
  "tommy-hilfiger-women-logo-skirt-fit-and-flare-white": "Skirt Fit And Flare",
  "tommy-hilfiger-women-logo-skirt-fit-and-flare-black": "Skirt Fit And Flare",
  "tommy-hilfiger-women-3-pack-bikini-briefs-multi": "3-pack Bikini Briefs",
  "tommy-hilfiger-women-bodycon-dress-embroidery-logo-black": "Bodycon Dress",
  "tommy-hilfiger-women-tie-back-dress-fit-and-flare-black": "Tie Back Dress",
  "tommy-hilfiger-women-cotton-shorts-essential-peach": "Cotton Shorts",
  "tommy-hilfiger-women-cotton-shorts-essential-grey": "Cotton Shorts",
  "tommy-hilfiger-women-cotton-shorts-essential-navy": "Cotton Shorts",
  "tommy-hilfiger-women-cotton-shorts-essential-black": "Cotton Shorts",
  "tommy-hilfiger-women-rib-tank-top-black": "Rib Tank Top",
  "tommy-hilfiger-women-pique-polo-slim-fit-black": "Pique Polo Slim Fit",
  "tommy-hilfiger-women-mock-neck-l-s-tee-sand": "Mock Neck L/S Tee",
  "tommy-hilfiger-women-regular-2-pack-tee-multi-3": "2-pack T-shirt",
  "tommy-hilfiger-women-v-neck-2-pack-tee-regular-fit-0xo": "V-Neck 2-pack Tee",
  "tommy-hilfiger-women-v-neck-l-s-organic-logo-tee-bordeaux": "V-Neck L/S Tee",
  "tommy-hilfiger-women-slim-fit-contrast-polo-navy": "Slim Fit Contrast Polo",
  "tommy-hilfiger-women-th-plaque-cap-navy": "TH Plaque Cap",
  "tommy-hilfiger-women-signature-cap-navy": "Signature Cap",
  "tommy-hilfiger-women-gold-buckle-reversible-belt-black-white": "2 in 1 Gold Buckle Belt",
  "tommy-hilfiger-women-gold-buckle-reversible-belt-black-sand": "2 in 1 Gold Buckle Belt",
  "tommy-hilfiger-women-logo-slip-on-white": "Logo Slip-on",
  "tommy-hilfiger-women-monogram-espadrilles-white": "Monogram Espadrilles",
  "tommy-hilfiger-women-monogram-espadrilles-beige": "Monogram Espadrilles",
  "tommy-hilfiger-women-th-logo-slides-navy": "TH Logo Slides",
  "tommy-hilfiger-women-th-logo-slides-beige": "TH Logo Slides",
  "tommy-hilfiger-women-small-logo-text-tee-white": "Small Logo Text Tee",
  "fila-women-logo-hoodie-black": "Logo Hoodie",
  "fila-logo-hoodie-black": "Logo Hoodie",
  "fila-women-logo-sweatpants-black": "Logo Sweatpants",
  "fila-logo-sweatpants-black": "Logo Sweatpants",
  "tommy-hilfiger-women-small-logo-text-tee-black": "Small Logo Text Tee",
  "hugo-boss-contrast-shorts-navy": "Swim Shorts Quick-Dry",
  "champion-rochester-shorts-signature-logo-navy": "Rochester Shorts",
  "champion-rochester-shorts-signature-logo-black": "Rochester Shorts",
  "champion-rochester-shorts-big-logo-black": "Rochester Shorts Big",
  "champion-rochester-shorts-big-logo-navy": "Rochester Shorts Big",
  "champion-rochester-pant-rib-cuff-signature-logo-black": "Rochester Logo Pants",
  "champion-rochester-pant-rib-cuff-signature-logo-navy": "Rochester Logo Pants",
  "champion-rochester-pant-rib-cuff-big-logo-black": "Rochester Big Pants",
  "champion-rochester-pant-rib-cuff-big-logo-navy": "Rochester Big Pants",
  "champion-rochester-crew-sweat-big-logo-black": "Rochester Sweat",
  "champion-rochester-crew-sweat-big-logo-navy": "Rochester Sweat",
  "champion-rochester-crew-sweat-big-logo-white": "Rochester Sweat",
  "champion-rochester-crew-sweat-big-logo-beige": "Rochester Sweat",
  "champion-rochester-crew-sweat-signature-logo-black": "Rochester Sweat",
  "champion-rochester-crew-sweat-signature-logo-navy": "Rochester Sweat",
  "champion-rochester-crew-sweat-signature-logo-beige": "Rochester Sweat",
  "champion-rochester-tee-big-logo-black": "Rochester Tee Big Logo",
  "champion-rochester-tee-big-logo-navy": "Rochester Tee Big Logo",
  "champion-rochester-tee-big-logo-white": "Rochester Tee Big Logo",
  "champion-rochester-tee-signature-logo-navy": "Rochester Tee",
  "champion-rochester-tee-signature-logo-black": "Rochester Tee",
  "champion-rochester-hood-signature-logo-navy": "Rochester Hood",
  "champion-rochester-hood-signature-logo-beige": "Rochester Hood",
  "champion-rochester-hood-signature-logo-white": "Rochester Hood",
  "champion-rochester-hood-signature-logo-black": "Rochester Hood",
  "champion-rochester-hood-big-logo-black": "Rochester Hood Big",
  "champion-rochester-hood-big-logo-white": "Rochester Hood Big",
  "champion-rochester-hood-big-logo-beige": "Rochester Hood Big",
  "champion-rochester-hood-big-logo-navy": "Rochester Hood Big",
  "nike-women-sport-bra-medium-black": "Sport Bra Medium",
  "nike-women-academy-pants-navy": "Academy Pants",
  "nike-women-shorts-academy-navy": "Shorts Academy",
  "nike-women-pro-tights-training-pants-black": "Pro Tights Pants",
  "nike-women-vi-park-s-s-tee-mint": "VI Park S/S Tee",
  "nike-women-vi-park-s-s-tee-sky": "VI Park S/S Tee",
  "nike-women-vi-park-s-s-tee-blue": "VI Park S/S Tee",
  "nike-s-s-dri-fit-division-tee-blue": "S/S Dri-FIT Division Tee",
  "nike-s-s-dri-fit-division-tee-blackgrey": "S/S Dri-FIT Division Tee",
  "nike-park-shorts-cotton-black": "Cotton Shorts Park",
  "nike-dri-fit-shorts-black": "Dri-FIT Shorts",
  "nike-vi-s-s-training-tee-white": "VI S/S Training Tee",
  "nike-club-zip-hoodie-black": "Club Zip Hoodie",
  "nike-club-zip-hoodie-navy": "Club Zip Hoodie",
  "nike-basic-hoodie-white": "Basic Hoodie",
  "nike-basic-hoodie-black": "Basic Hoodie",
  "nike-vi-l-s-training-tee-black": "VI L/S Training Tee",
  "rains-women-1201-jacket-river": "1201 Jacket",
  "rains-women-1545-trekker-scuba-jacket-black": "1545 Trekker",
  "rains-women-1866-fleece-pants-black": "1866 Fleece Pants",
  "rains-1866-fleece-pants-black": "1866 Fleece Pants",
  "rains-1545-trekker-scuba-jacket-black": "1545 Trekker",
  "armani-ea7-core-id-track-top-everglade": "EA7 Core ID Track Top",
  "armani-ea7-giacca-light-jacket-black": "EA7 GIACCA Light Jacket",
  "armani-ea7-core-id-track-top-black": "EA7 Core ID Track Top",
  "armani-ea7-core-id-track-pants-black": "EA7 Core ID Track Pants",
  "gant-3-pack-trunks-cotton-stretch-multi": "3-pack Trunks",
  "gant-3-pack-trunks-cotton-stretch-black": "3-pack Trunks",
  "gant-women-gold-shield-crew-sweatshirt-grey": "Shield Crew Sweat",
  "gant-women-retro-shield-sweatshirt-rose": "Retro Shield Sweat",
  "gant-women-retro-shield-sweatshirt-navy": "Retro Shield Sweat",
  "gant-down-vest-gilet-black": "Down Vest Gilet",
  "gant-women-gold-shield-hoodie-grey": "Gold Shield Hoodie",
  "gant-women-gold-shield-hoodie-navy": "Gold Shield Hoodie",
  "gant-women-gold-shield-hoodie-sand": "Gold Shield Hoodie",
  "gant-women-gold-shield-hoodie-eggshell": "Gold Shield Hoodie",
  "gant-women-gold-shield-logo-tee-black": "Gold Shield Logo Tee",
  "gant-women-gold-shield-logo-tee-navy": "Gold Shield Logo Tee",
  "gant-women-gold-shield-logo-tee-sand": "Gold Shield Logo Tee",
  "rains-1201-jacket-river": "1201 Jacket",
  "gant-broad-shirt-short-sleeve-black": "Broad Shirt S/S",
  "gant-basic-s-s-tee-antracit": "Basic S/S Tee",
  "gant-pique-s-s-polo-regular-black": "Piqué S/S Polo Regular",
  "gant-pique-s-s-polo-regular-navy": "Piqué S/S Polo Regular",
  "hugo-boss-swoven-jacket-black": "Swoven Jacket",
  "gant-sweatpants-shield-logo-black": "Sweatpants Shield",
  "gant-shield-shorts-cotton-black": "Shield Shorts Cotton",
  "gant-gold-shield-sweatpants-black": "Shield Sweatpants",
  "gant-gold-shield-chest-logo-hoodie-black": "Gold Shield Hoodie",
  "hugo-boss-patch-wetalk-logo-hoodie-army": "Wetalk Logo Hoodie",
  "hugo-boss-westart-patch-logo-sweatshirt-army": "Westart Patch Sweat",
  "gant-gold-shield-chest-logo-hoodie-navy": "Gold Shield Hoodie",
  "gant-gold-shield-hoodie-black": "Gold Shield Hoodie",
  "gant-gold-shield-hoodie-navy": "Gold Shield Hoodie",
  "gant-sailing-club-hoodie-navy": "Sailing Club Hoodie",
  "tommy-hilfiger-women-sweatpants-navy": "Sweatpants",
  "tommy-hilfiger-women-v-neck-2-pack-tee-regular-fit-0xq": "V-Neck 2-pack Tee",
  "tommy-hilfiger-women-regular-2-pack-tee-multi-2": "2-pack T-shirt",
  "tommy-hilfiger-women-v-neck-l-s-organic-logo-tee-grey": "V-Neck L/S Tee",
  "tommy-hilfiger-women-sweatshirt-logo-navy": "Sweatshirt Logo",
  "tommy-hilfiger-women-slim-2-pack-tee-tj-multi": "Slim 2-pack Tee",
  "tommy-hilfiger-women-mock-neck-l-s-tee-grey": "Mock Neck L/S Tee",
  "tommy-hilfiger-women-tee-text-logo-lagoon": "Tee Text Logo",
  "tommy-hilfiger-women-tee-text-logo-black": "Tee Text Logo",
  "tommy-hilfiger-women-sweatpants-black": "Sweatpants",
  "tommy-hilfiger-women-outline-flag-hoodie-black": "Outline Flag Hoodie",
  "tommy-hilfiger-women-relaxed-signature-tee-black": "Relaxed Signature Tee",
  "tommy-hilfiger-women-puffer-vest-white": "Puffer Vest",
  "tommy-hilfiger-women-slim-fit-v-neck-stripe-tee-white-red": "Slim V-Neck Stripe Tee",
  "tommy-hilfiger-women-slim-fit-v-neck-stripe-tee-white-navy": "Slim V-Neck Stripe Tee",
  "tommy-hilfiger-women-down-filled-vest-sky": "Down Filled Vest",
  "tommy-hilfiger-women-essential-hoodie-scarlet": "Est. Logo Hoodie",
  "tommy-hilfiger-women-cotton-dress-drawstring-white": "Cotton Dress",
  "tommy-hilfiger-women-relaxed-blouse-v-neck-black": "Relaxed Blouse V-Neck",
  "tommy-hilfiger-women-sport-bra-black": "Sport Bra",
  "tommy-hilfiger-women-relaxed-blouse-v-neck-white": "Relaxed Blouse V-Neck",
  "tommy-hilfiger-women-regular-logo-hoodie-black": "Hoodie Regular Logo",
  "tommy-hilfiger-women-rib-tank-top-red": "Rib Tank Top",
  "tommy-hilfiger-women-cami-dress-navy": "Cami Dress",
  "tommy-hilfiger-women-curved-tee-white": "Curved Tee",
  "tommy-hilfiger-women-curved-tee-navy": "Curved Tee",
  "tommy-hilfiger-women-cami-dress-red": "Cami Dress",
  "tommy-hilfiger-women-sport-tape-bra-medium-support-navy": "Sport Tape Bra",
  "fila-women-logo-tee-white": "Logo Tee",
  "fila-women-logo-tee-grey": "Logo Tee",
  "fila-women-logo-tee-black": "Logo Tee",
  "fila-women-logo-tee-navy": "Logo Tee",
  "fila-women-logo-sweatshirt-grey": "Logo Sweatshirt",
  "fila-women-logo-sweatshirt-black": "Logo Sweatshirt",
  "fila-women-logo-hoodie-grey": "Logo Hoodie",
  "fila-women-logo-sweatpants-grey": "Logo Sweatpants",
  "fila-logo-sweatpants-grey": "Logo Sweatpants",
  "fila-logo-hoodie-grey": "Logo Hoodie",
  "fila-logo-tee-grey": "Logo Tee",
  "fila-logo-tee-black": "Logo Tee",
  "fila-logo-tee-white": "Logo Tee",
  "fila-logo-tee-navy": "Logo Tee",
  "fila-logo-sweatshirt-grey": "Logo Sweatshirt",
  "fila-logo-sweatshirt-black": "Logo Sweatshirt",
  "fila-box-logo-sweatpants-black": "Box Logo Sweatpants",
  "fila-2-pack-tee-white-black": "2-pack Tee",
  "fila-2-pack-tee-white-navy": "2-pack Tee",
  "fila-chest-logo-hoodie-black": "Box Logo Hoodie",
  "fila-logo-shorts-black": "Box Logo Shorts",
  "nike-women-next-nature-sneakers-white": "Next Nature Sneakers",
  "nike-women-logo-slides-white": "Comfort Slides",
  "nike-revolution-6-trainers-grey": "Revolution 6 Trainers",
  "resterods-10-pack-bamboo-boxers-multi": "10-pack Bamboo Boxers",
  "resterods-10-pack-bamboo-boxers-black": "10-pack Bamboo Boxers",
  "resterods-bamboo-shorts-black": "Bamboo Shorts",
  "lacoste-women-sport-socks-3-pack-white": "Sport Socks 3-pack",
  "lacoste-women-sport-socks-3-pack-black": "Sport Socks 3-pack",
  "lacoste-women-bikini-bottom-green": "Bikini Bottom",
  "lacoste-women-bikini-top-green": "Bikini Top",
  "lacoste-women-bikini-top-red": "Bikini Top",
  "lacoste-logo-pocket-shirt-navy": "Pocket Shirt Logo",
  "lacoste-s-s-regular-shirt-white": "S/S Shirt",
  "lacoste-sport-socks-3-pack-white": "Sport Socks 3-pack",
  "lacoste-sport-socks-3-pack-black": "Sport Socks 3-pack",
  "armani-ea7-polo-line-logo-shirt-navy": "EA7 Polo Line Shirt",
  "armani-ea7-id-logo-hoodie-indigo": "EA7 ID Logo Hoodie",
  "armani-ea7-id-logo-sweatshirt-gold": "EA7 ID Logo Sweatshirt",
  "armani-ea7-regular-hoodie-big-logo-white": "EA7 Hoodie Big",
  "armani-ea7-padded-light-jacket-grey": "EA7 Padded Jacket",
  "ralph-lauren-soft-touch-tee-grey": "Soft-Touch Tee",
  "ralph-lauren-soft-touch-tee-royal": "Soft-Touch Tee",
  "lacoste-regular-v-neck-s-s-logo-tee-navy": "Regular V-Neck Tee",
  "lacoste-leather-trainer-sneakers-white": "Trainer Sneaker",
  "lacoste-regular-v-neck-s-s-logo-tee-white": "Regular V-Neck Tee",
  "lacoste-zip-knit-pullover-grey": "Zip Knit Pullover",
  "ralph-lauren-slim-denim-shirt-dark": "Slim Denim Shirt",
  "lacoste-women-gold-logo-sneakers-black": "Gold Logo Sneakers",
  "lacoste-women-logo-slides-black": "Logo Slides",
  "lacoste-women-logo-slides-white": "Logo Slides",
  "lacoste-knitted-pullover-black": "Knit Pullover",
  "lacoste-knitted-v-neck-pullover-black": "Knitted V-Neck Knit",
  "resterods-bamboo-hoodie-grey": "Bamboo Hoodie",
  "resterods-swim-shorts-black": "Swim Shorts Quick Dry",
  "resterods-bamboo-sweatshirt-grey": "Bamboo Sweatshirt",
  "calvin-klein-non-quilt-vest-grey": "Non-Quilt Vest",
  "calvin-klein-non-quilt-vest-black": "Non-Quilt Vest",
  "hugo-boss-trunks-3-pack-color-971": "Trunks 3-pack",
  "hugo-boss-no-show-socks-white": "2-Pack No-Show Socks",
  "hugo-boss-embroidered-v-neck-2-pack-tee-black": "V-Neck 2-Pack Tee",
  "hugo-boss-embroidered-2-pack-tee-black": "2-Pack Tee",
  "hugo-boss-boxers-3-pack-grey": "Boxers 3-pack",
  "calvin-klein-badge-padded-jacket-black": "Badge Padded Jacket",
  "calvin-klein-women-essential-logo-dress-black": "Essential Logo Dress",
  "calvin-klein-women-icon-logo-tee-white": "Icon Logo Tee",
  "adidas-climalite-shorts-white": "Climalite Shorts",
  "tommy-hilfiger-women-metallic-logo-tee-black": "Metallic Logo Tee",
  "tommy-hilfiger-women-quilted-hooded-jacket-olive": "Quilted Hooded Jacket",
  "tommy-hilfiger-women-hooded-down-jacket-navy": "Hooded Down Jacket",
  "tommy-hilfiger-women-hooded-down-jacket-army": "Hooded Down Jacket",
  "tommy-hilfiger-women-heart-flag-cropped-l-s-tee-black": "Heart Flag L/S Tee",
  "tommy-hilfiger-women-hooded-down-jacket-black": "Hooded Down Jacket",
  "tommy-hilfiger-women-heart-flag-hoodie-red": "Heart Flag Hoodie",
  "tommy-hilfiger-women-heart-flag-hoodie-white": "Heart Flag Hoodie",
  "tommy-hilfiger-women-metallic-cropped-tee-white": "Metallic Cropped Tee",
  "tommy-hilfiger-women-heart-flag-tee-beige": "Heart Flag Tee",
  "tommy-hilfiger-women-metallic-logo-tee-pink": "Metallic Logo Tee",
  "adidas-stripe-sweatshirt-black": "Stripe Sweatshirt",
  "adidas-stripe-zip-hoodie-black": "Stripe Zip Hoodie",
  "lacoste-women-storm-96-athletic-lo-sneakers-white-white": "Storm 96 Lo",
  "nike-legend-l-s-training-tee-white": "Legend L/S Training Tee",
  "adidas-climalite-shorts-navy": "Climalite Shorts",
  "tommy-hilfiger-women-middle-logo-hoodie-army": "Center Badge Hoodie",
  "tommy-hilfiger-women-middle-logo-hoodie-black": "Center Badge Hoodie",
  "nike-dri-fit-1-2-zip-training-shirt-black": "Dri-FIT 1/2 Zip",
  "nike-women-dri-fit-midlayer-half-zip-grey": "Dri-FIT Half-Zip",
  "nike-women-dri-fit-midlayer-half-zip-black": "Dri-FIT Half-Zip",
  "nike-women-dri-fit-midlayer-half-zip-amethyst": "Dri-FIT Half-Zip",
  "nike-park-track-pants-navy": "Park Track Pants",
  "adidas-performance-tee-white": "Performance Tee",
  "adidas-performance-tee-black": "Performance Tee",
  "hugo-boss-trunks-3-pack-color-480": "Trunks 3-pack",
  "calvin-klein-women-bikini-briefs-3-pack-multi": "Bikini Briefs 3-pack",
  "calvin-klein-women-lift-bralette-white": "Lift Bralette",
  "calvin-klein-women-lift-bralette-black": "Lift Bralette",
  "calvin-klein-women-unlined-bralette-grey": "Unlined Bralette",
  "calvin-klein-women-unlined-bralette-white": "Unlined Bralette",
  "tommy-hilfiger-women-pure-cotton-sweater-navy": "Pure Cotton Blouse",
  "tommy-hilfiger-women-logo-hoodie-black": "Logo Hoodie",
  "tommy-hilfiger-women-regular-logo-tee-black-1": "Regular Logo Tee",
  "tommy-hilfiger-women-v-neck-l-s-organic-logo-tee-black": "V-Neck L/S Tee",
  "tommy-hilfiger-women-mock-neck-l-s-tee-black": "Mock Neck L/S Tee",
  "cr7-trunks-5-pack-special-edition-black": "5-pack Trunks",
  "resterods-tank-top-2-pack-organic-white": "Tank Top 2-Pack",
  "resterods-tank-top-2-pack-organic-black": "Tank Top 2-Pack",
  "calvin-klein-essential-shadow-logo-hoodie-black": "Shadow Hoodie",
  "calvin-klein-hoodie-essential-logo-black": "Hoodie Essential Logo",
  "columbia-powder-puffer-jacket-navy": "Powder Puffer Jacket",
  "nike-sweatpants-park-sort": "Sweatpants Park",
  "armani-sweatshirt-emporio-logo-navy": "Sweat Emporio Logo",
  "armani-sweatshirt-emporio-logo-black": "Sweat Emporio Logo",
  "armani-l-s-tee-emporio-logo-navy": "L/S Tee Emporio Logo",
  "armani-l-s-tee-emporio-logo-black": "L/S Tee Emporio Logo",
  "nike-sweatpants-park-grey": "Sweatpants Park",
  "peak-performance-essential-logo-tee-navy": "Original Tee",
  "peak-performance-essential-logo-tee-black": "Original Tee",
  "peak-performance-down-jacket-grey": "Down Jacket",
  "peak-performance-down-jacket-black": "Down Jacket",
  "peak-performance-down-jacket-navy": "Down Jacket",
  "hugo-boss-l-s-regular-polo-brushed-pique-marine": "L/S Piqué Polo Regular",
  "under-armour-trunks-3-pack-multi": "Boxers 3-pack",
  "under-armour-trainers-essential-black": "Trainers Essential",
  "under-armour-tracksuit-challenger-grey": "Tracksuit Challenger",
  "under-armour-rival-fleece-sweatshirt-black": "Rival Fleece Sweat",
  "under-armour-rival-hoodie-navy": "Rival Hoodie",
  "under-armour-rival-fleece-hoodie-navy": "Rival Fleece Hoodie",
  "under-armour-rival-fleece-hoodie-black": "Rival Fleece Hoodie",
  "under-armour-trunks-3-pack-royal": "Boxers 3-pack",
  "under-armour-trunks-3-pack-black": "Boxers 3-pack",
  "under-armour-challenger-tee-midnight": "Challenger Tee",
  "under-armour-boxers-3-pack-black": "Trunks 3-pack",
  "under-armour-speed-stride-1-2-zip-black": "Speed Stride 1/2 Zip",
  "under-armour-speed-stride-1-2-zip-blue": "Speed Stride 1/2 Zip",
  "under-armour-boxed-tee-black": "Boxed Tee",
  "under-armour-challenger-midlayer-jersey-black": "Challenger Midlayer",
  "under-armour-launch-7-shorts-grey": "Launch 7\" Shorts",
  "under-armour-l-s-tech-tee-carbon": "L/S Tech Tee",
  "under-armour-l-s-tech-tee-navy": "L/S Tech Tee",
  "under-armour-challenger-midlayer-jersey-midnight": "Challenger Midlayer",
  "under-armour-outrun-the-rain-jacket-black": "OutRun The Rain Jacket",
  "under-armour-tech-1-4-zip-navy": "Tech 1/4 Zip",
  "under-armour-tech-1-4-zip-ash": "Tech 1/4 Zip",
  "under-armour-foundati-tee-white": "Foundati Tee",
  "under-armour-engineered-tee-white": "Engineered Tee",
  "under-armour-full-zip-rival-hoodie-black": "Zip Rival Hoodie",
  "under-armour-foundati-tee-ash": "Foundati Tee",
  "under-armour-tech-tee-white": "Tech Tee",
  "under-armour-tech-tee-ash": "Tech Tee",
  "under-armour-tech-2-0-polo-black": "Tech 2.0 Polo",
  "gant-basic-s-s-tee-white": "Basic S/S Tee",
  "gant-basic-s-s-tee-black": "Basic S/S Tee",
  "gant-zip-cardigan-regular-black": "Zip Cardigan Regular",
  "gant-zip-cardigan-regular-grey": "Zip Cardigan Regular",
  "gant-basic-hoodie-black": "Basic Hoodie",
  "gant-basic-hoodie-marine": "Basic Hoodie",
  "gant-basic-crew-sweatshirt-black": "Basic Crew Sweatshirt",
  "gant-gold-shield-logo-tee-navy": "Gold Shield Logo Tee",
  "gant-gold-shield-logo-tee-white": "Gold Shield Logo Tee",
  "gant-gold-shield-pique-polo-regular-navy": "Gold Shield Polo",
  "gant-gold-shield-pique-polo-regular-black": "Gold Shield Polo",
  "ellesse-ornari-full-zip-hoodie-navy": "Ornari Zip Hoodie",
  "ellesse-salia-sweatshirt-grey": "Salia Sweatshirt",
  "ellesse-salia-sweatshirt-navy": "Salia Sweatshirt",
  "ellesse-marzo-track-top-navy": "Marzo Track Top",
  "ellesse-bovaro-1-4-zip-navy": "Bovaro 1/4 Zip",
  "armani-emporio-boxers-3-pack-black": "Emporio Trunks 3-pack",
  "armani-emporio-boxers-3-pack-multi": "Emporio Trunks 3-pack",
  "armani-eagle-boxers-3-pack-multi": "Eagle Trunks 3-pack",
  "nike-women-essential-logo-tee-pink": "Essential Logo Tee",
  "nike-women-nsw-club-sweat-black": "NSW Club Sweat",
  "nike-women-l-s-icon-tee-grey": "L/S Icon Tee",
  "nike-women-sport-bra-swoosh-white": "Sport Bra Swoosh",
  "nike-sweatpants-park-navy": "Sweatpants Park",
  "nike-club-sweatshirt-navy": "Club Sweatshirt",
  "nike-club-sweatshirt-black": "Club Sweatshirt",
  "nike-basic-hoodie-grey": "Basic Hoodie",
  "nike-club-zip-hoodie-grey": "Club Zip Hoodie",
  "nike-nsw-club-sweatshirt-grey": "NSW Club Sweatshirt",
  "nike-nsw-club-sweatshirt-black": "NSW Club Sweatshirt",
  "tommy-hilfiger-women-pure-cotton-sweater-black": "Pure Cotton Blouse",
  "tommy-hilfiger-women-pure-cotton-sweater-beige": "Pure Cotton Blouse",
  "tommy-hilfiger-women-v-neck-knit-sweater-red": "V-Neck Knit",
  "tommy-hilfiger-women-timeless-logo-tee-navy": "Timeless Logo Tee",
  "tommy-hilfiger-women-mock-neck-l-s-tee-navy": "Mock Neck L/S Tee",
  "tommy-hilfiger-women-mock-neck-l-s-tee-olive": "Mock Neck L/S Tee",
  "tommy-hilfiger-women-v-neck-knit-sweater-butter": "V-Neck Knit",
  "tommy-hilfiger-women-v-neck-knit-sweater-black": "V-Neck Knit",
  "tommy-hilfiger-women-circle-logo-sweatshirt-beige": "Circle Logo Sweat",
  "tommy-hilfiger-women-essential-down-jacket-red": "Essential Down Jacket",
  "tommy-hilfiger-women-v-neck-knit-sweater-navy": "V-Neck Knit",
  "tommy-hilfiger-women-v-neck-l-s-organic-logo-tee-white": "V-Neck L/S Tee",
  "tommy-hilfiger-women-v-neck-l-s-organic-logo-tee-red": "V-Neck L/S Tee",
  "tommy-hilfiger-women-v-neck-l-s-organic-logo-tee-navy": "V-Neck L/S Tee",
  "tommy-hilfiger-women-regular-logo-tee-beige": "Regular Logo Tee",
  "columbia-csc-logo-basic-tee-sand": "CSC Logo Basic Tee",
  "lacoste-women-gold-carnaby-sneaker-black": "Gold Carnaby Sneaker",
  "tommy-hilfiger-women-regular-logo-tee-army": "Regular Logo Tee",
  "tommy-hilfiger-women-tjw-v-neck-logo-tee-black": "TJW V-Neck Logo Tee",
  "tommy-hilfiger-women-middle-logo-sweatshirt-beige": "Middle Logo Sweat",
  "tommy-hilfiger-women-middle-logo-sweatshirt-black": "Middle Logo Sweat",
  "tommy-hilfiger-women-heart-flag-cropped-sweatshirt-white": "Heart Flag L/S Tee",
  "tommy-hilfiger-women-heart-flag-hoodie-black": "Heart Flag Hoodie",
  "tommy-hilfiger-women-heart-flag-tee-white": "Heart Flag Tee",
  "tommy-hilfiger-women-heart-flag-tee-black": "Heart Flag Tee",
  "tommy-hilfiger-women-heart-flag-tee-red": "Heart Flag Tee",
  "armani-ea7-id-logo-zip-hoodie-grey": "EA7 ID Logo Zip Hoodie",
  "calvin-klein-lightweight-side-logo-puffer-jacket-navy": "Side Puffer Jacket",
  "calvin-klein-lightweight-side-logo-puffer-jacket-black": "Side Puffer Jacket",
  "ralph-lauren-v-neck-knit-pullover-black": "Pima V-Neck Knit",
  "ralph-lauren-double-knit-sweatshirt-cream": "Double Knit Sweat",
  "hugo-boss-tchark-chest-l-s-tee-sort": "TChark Chest L/S Tee",
  "hugo-boss-big-logo-l-s-tee-navy": "Big Logo L/S Tee",
  "armani-slim-l-s-tee-emporio-logo-black": "Slim L/S Tee Emporio",
  "armani-turtleneck-slim-jersey-navy": "Turtleneck Slim Jersey",
  "armani-2-pack-tee-navy": "2-Pack Tee",
  "armani-2-pack-tee-black": "2-Pack Tee",
  "nike-performance-shorts-black": "Performance Shorts",
  "emporio-armani-boxers-3-pack-signature": "3-pack Trunks",
  "armani-women-2-pack-thong-iconic-cotton-black-white": "2-pack Iconic Thong",
  "armani-women-2-pack-thong-black-black": "2-Pack Thong",
  "armani-women-2-pack-thong-black-nude": "2-Pack Thong",
  "armani-turtleneck-logo-black": "Turtleneck Slim Jersey",
  "nike-women-sweatpants-navy": "Sweatpants",
  "ellesse-marzo-track-top-black": "Marzo Track Top",
  "ellesse-beltona-hoodie-navy": "Beltona Hoodie",
  "ellesse-patri-track-jacket-navy": "Patri Track Jacket",
  "luxivo-gift-card": "Gift Card",
  "lacoste-sport-s-s-logo-tee-black": "Sport S/S Logo Tee",
  "hugo-boss-patch-logo-l-s-tee-silver": "Patch Logo L/S Tee",
  "hugo-boss-patch-logo-l-s-tee-black": "Patch Logo L/S Tee",
  "lacoste-sport-pique-s-s-polo-black": "Sport Pique S/S Polo",
  "lacoste-sport-pique-s-s-polo-navy": "Sport Pique S/S Polo",
  "tommy-hilfiger-women-th-gold-buckle-leather-belt-white": "Gold Buckle Belt",
  "hugo-boss-patch-logo-l-s-tee-navy": "Patch Logo L/S Tee",
  "hugo-boss-patch-logo-l-s-tee-white": "Patch Logo L/S Tee",
  "ralph-lauren-canvas-sneaker-white": "Canvas Sneaker",
  "resterods-basic-t-shirt-black": "Flex Cotton T-shirt",
  "calvin-klein-padded-badge-jacket-navy": "Padded Basic Jacket",
  "calvin-klein-badge-tee-white": "Badge Tee",
  "calvin-klein-lightweight-puffer-vest-black": "Light Puffer Vest",
  "nike-women-no-show-socks-3-pack-black": "No-Show Socks 3-pack",
  "tommy-hilfiger-women-slim-stripe-l-s-tee-white": "Slim Stripe L/S Tee",
  "tommy-hilfiger-women-side-stitch-jumper-pink": "Side Stitch Jumper",
  "tommy-hilfiger-women-ribbed-dress-black": "Ribbed Dress",
  "tommy-hilfiger-women-heart-v-neck-tee-navy": "Heart V-Neck Tee",
  "tommy-hilfiger-women-side-stitch-jumper-navy": "Side Stitch Jumper",
  "tommy-hilfiger-women-tjw-v-neck-logo-tee-white": "TJW V-Neck Logo Tee",
  "tommy-hilfiger-women-tjw-v-neck-logo-tee-navy": "TJW V-Neck Logo Tee",
  "tommy-hilfiger-women-regular-logo-tee-white": "Regular Logo Tee",
  "tommy-hilfiger-women-ss-regular-logo-tee-red": "Regular Logo Tee",
  "tommy-hilfiger-women-ss-regular-logo-tee-navy": "Regular Logo Tee",
  "armani-ea7-knitted-v-neck-shield-logo-jumper-black": "EA7 Shield V-Neck Knit",
  "armani-ea7-down-shield-giacca-logo-jacket-black": "EA7 Shield Jacket",
  "armani-ea7-id-logo-hoodie-grey": "EA7 ID Logo Hoodie",
  "armani-ea7-core-id-l-s-tee-grey": "EA7 Core ID L/S Tee",
  "tommy-hilfiger-women-leather-sneaker-navy": "Leather Sneaker",
  "tommy-hilfiger-women-signature-logo-sneaker-white": "Signature Sneaker",
  "ralph-lauren-double-knit-sweatshirt-black": "Double Knit Sweat",
  "ralph-lauren-soft-touch-polo-slim-fit-black": "-Touch Polo Slim",
  "ralph-lauren-new-knit-pullover-grey": "Pima Knit Pullover",
  "ralph-lauren-soft-touch-polo-slim-fit-navy": "-Touch Polo Slim",
  "ralph-lauren-soft-touch-polo-slim-fit-grey": "-Touch Polo Slim",
  "ralph-lauren-soft-touch-polo-slim-fit-beige": "-Touch Polo Slim",
  "ralph-lauren-soft-touch-tee-black": "Soft-Touch Tee",
  "ralph-lauren-cable-knit-pullover-navy": "Cable Knit Pullover",
  "tommy-hilfiger-women-classic-bikini-bottom-white": "Classic Bikini Bottom",
  "tommy-hilfiger-women-bralette-bikini-top-white": "Bralette Bikini Top",
  "tommy-hilfiger-women-bralette-bikini-top-red": "Bralette Bikini Top",
  "tommy-hilfiger-women-classic-hoodie-navy": "Classic Hoodie",
  "tommy-hilfiger-women-classic-sweat-black": "Classic Sweat",
  "tommy-hilfiger-women-classic-sweat-navy": "Classic Sweat",
  "cr7-3-pack-cotton-stretch-no-show-socks-white": "3-pack No-Show Socks",
  "cr7-3-pack-cotton-stretch-no-show-socks-black": "3-pack No-Show Socks",
  "columbia-windbreaker-jacket-black": "Windbreaker Jacket",
  "columbia-csc-logo-basic-tee-black": "CSC Logo Basic Tee",
  "columbia-csc-logo-basic-tee-navy": "CSC Logo Basic Tee",
  "columbia-back-graphic-tee-black": "Back Graphic Tee",
  "resterods-organic-trunks-5-pack-black": "5-pack Organic Trunks",
  "columbia-rapid-box-logo-tee-military": "Rapid Box Logo Tee",
  "resterods-organic-trunks-3-pack-navy": "3-pack Organic Trunks",
  "resterods-organic-trunks-3-pack-black": "3-pack Organic Trunks",
  "columbia-rapid-ridge-logo-tee-beige": "Rapid Ridge Logo Tee",
  "nike-basic-hoodie-navy": "Basic Hoodie",
  "nike-park-s-s-tee-black": "Park S/S Tee",
  "lacoste-classic-l-s-polo-pike-black": "Classic L/S Polo Piké",
  "lacoste-classic-l-s-polo-pike-navy": "Classic L/S Polo Piké",
  "emporio-armani-boxers-3-pack-ngw": "Emporio 3-pack",
  "calvin-klein-women-thong-3-pack-wzb": "Thong 3-pack",
  "lacoste-regular-v-neck-s-s-logo-tee-black": "Regular V-Neck Tee",
  "lacoste-regular-s-s-polo-pike-chevril": "Classic Polo Piké",
  "lacoste-smooth-card-holder-black-leather": "Card Holder",
  "timberland-1973-s-s-tee-grey": "1973 S/S Tee",
  "timberland-bucket-hat-black": "Bucket Hat",
  "timberland-1973-crew-sweatshirt-army": "1973 Crew Sweatshirt",
  "timberland-1973-crew-sweatshirt-grey": "1973 Crew Sweatshirt",
  "gant-shield-hoodie-grey": "Shield Hoodie",
  "gant-shield-hoodie-black": "Shield Hoodie",
  "gant-shield-hoodie-navy": "Shield Hoodie",
  "gant-shield-hoodie-white": "Shield Hoodie",
  "gant-basic-s-s-tee-grey": "Basic S/S Tee",
  "gant-basic-s-s-tee-navy": "Basic S/S Tee",
  "gant-pique-s-s-polo-regular-sky": "Piqué S/S Polo Regular",
  "gant-basic-hoodie-navy": "Basic Hoodie",
  "gant-basic-crew-sweatshirt-grey": "Basic Crew Sweatshirt",
  "gant-basic-crew-sweatshirt-navy": "Basic Crew Sweatshirt",
  "gant-basic-crew-sweatshirt-white": "Basic Crew Sweatshirt",
  "gant-gold-shield-crew-sweatshirt-grey": "Shield Crew Sweat",
  "gant-gold-shield-crew-sweatshirt-black": "Shield Crew Sweat",
  "gant-gold-shield-crew-sweatshirt-navy": "Shield Crew Sweat",
  "tommy-hilfiger-women-slim-fit-polo-blue": "Slim Fit Polo",
  "tommy-hilfiger-women-s-s-stripe-polo-red": "S/S Stripe Polo",
  "tommy-hilfiger-women-bodycon-skirt-red-stripe": "BodyCon Skirt",
  "tommy-hilfiger-women-v-neck-sweatshirt-white": "V-Neck Sweater",
  "tommy-hilfiger-women-v-neck-sweatshirt-black": "V-Neck Sweater",
  "tommy-hilfiger-women-cable-knit-pullover-red": "Cable Knit Pullover",
  "tommy-hilfiger-women-organic-stripe-tee-white": "Organic Stripe Tee",
  "tommy-hilfiger-women-boat-neck-logo-tee-red": "Boat Neck Logo Tee",
  "tommy-hilfiger-women-essential-zip-thru-tee-navy": "Essential Zip-thru Tee",
  "tommy-hilfiger-women-camisole-top-white": "Camisole Top",
  "tommy-hilfiger-women-camisole-top-red": "Camisole Top",
  "tommy-hilfiger-women-camisole-top-navy": "Camisole Top",
  "tommy-hilfiger-women-slim-fit-polo-red": "Slim Fit Polo",
  "tommy-hilfiger-women-regular-logo-tee-silver": "Regular Tee Silver",
  "tommy-hilfiger-women-ribbed-bikini-bottom-navy": "Ribbed Bikini Bottom",
  "tommy-hilfiger-women-core-bikini-bottom-navy": "Core Bikini Bottom",
  "tommy-hilfiger-women-denim-flag-logo-shorts-white": "Denim Flag Shorts",
  "tommy-hilfiger-women-down-filled-vest-red": "Down Filled Vest",
  "tommy-hilfiger-women-knit-jumper-pink": "Knit Jumper Soft",
  "tommy-hilfiger-women-denim-shorts-blue": "Denim Shorts",
  "tommy-hilfiger-women-knit-jumper-blue": "Knit Jumper Soft",
  "tommy-hilfiger-women-circle-sweatshirt-red": "Circle Sweatshirt",
  "tommy-hilfiger-women-organic-jumper-navy": "Organic Jumper",
  "tommy-hilfiger-women-essential-tee-red": "Essential Tee",
  "tommy-hilfiger-women-s-s-polo-yellow": "S/S Polo",
  "tommy-hilfiger-women-s-s-stripe-polo-white": "S/S Stripe Polo",
  "tommy-hilfiger-women-essential-hoodie-red": "Est. Logo Hoodie",
  "tommy-hilfiger-women-boat-neck-jumper-white": "Boat Neck Jumper",
  "tommy-hilfiger-women-denim-skirt-dark": "Denim Skirt",
  "tommy-hilfiger-women-boat-neck-jumper-navy": "Boat Neck Jumper",
  "tommy-hilfiger-women-denim-skirt-flag-logo": "Denim Skirt Flag Logo",
  "tommy-hilfiger-women-circle-sweatshirt-navy": "Circle Sweatshirt",
  "tommy-hilfiger-women-essential-tee-white": "Essential Tee",
  "tommy-hilfiger-women-essential-tee-grey": "Essential Tee",
  "tommy-hilfiger-women-essential-tee-midnight": "Essential Tee",
  "tommy-hilfiger-women-essential-hoodie-grey": "Est. Logo Hoodie",
  "tommy-hilfiger-women-essential-hoodie-navy": "Est. Logo Hoodie",
  "tommy-hilfiger-women-essential-hoodie-black": "Est. Logo Hoodie",
  "lyle-scott-regular-tee-black": "T-shirt",
  "lyle-scott-regular-tee-navy": "T-shirt",
  "lyle-scott-regular-tee-white": "T-shirt",
  "lyle-scott-l-s-tee-white": "L/S Tee",
  "lyle-scott-merino-v-neck-knit-black": "Merino V-Neck Knit",
  "lyle-scott-merino-v-neck-knit-grey": "Merino V-Neck Knit",
  "lyle-scott-merino-v-neck-knit-navy": "Merino V-Neck Knit",
  "lyle-scott-merino-crew-knit-black": "Merino Crew Knit",
  "lyle-scott-regular-polo-shirt-navy1": "Polo Shirt",
  "lyle-scott-regular-polo-shirt-black": "Polo Shirt",
  "lyle-scott-crew-sweat-navy": "Crew Sweat",
  "lyle-scott-logo-hoodie-grey": "Logo Hoodie",
  "lyle-scott-zip-track-top-grey": "Zip Track Top",
  "lyle-scott-zip-track-top-navy": "Zip Track Top",
  "lyle-scott-padded-gillet-vest-black": "Padded Gillet Vest",
  "lacoste-women-croco-slides-white": "Croco Slides",
  "lacoste-women-croco-slides-pink": "Croco Slides",
  "armani-ea7-id-logo-hoodie-navy": "EA7 ID Logo Hoodie",
  "armani-s-s-logo-tee-2-pack-navy": "Logo Tee 2-Pack",
  "armani-s-s-logo-tee-2-pack-black": "Logo Tee 2-Pack",
  "armani-s-s-logo-tee-2-pack-white": "Logo Tee 2-Pack",
  "timberland-oxford-stretch-shirt-navy": "Oxford Stretch Shirt",
  "timberland-oxford-stretch-shirt-black": "Oxford Stretch Shirt",
  "tommy-hilfiger-women-slim-fit-logo-tee-white": "Slim Fit Logo Tee",
  "tommy-hilfiger-women-slim-fit-logo-tee-navy": "Slim Fit Logo Tee",
  "tommy-hilfiger-women-slim-fit-logo-tee-black": "Slim Fit Logo Tee",
  "tommy-hilfiger-women-regular-logo-tee-navy": "Regular Logo Tee",
  "tommy-hilfiger-women-regular-logo-tee-black": "Regular Logo Tee",
  "tommy-hilfiger-women-slim-fit-polo-white": "Slim Fit Polo",
  "tommy-hilfiger-women-slim-fit-polo-navy": "Slim Fit Polo",
  "tommy-hilfiger-women-slim-fit-polo-black": "Slim Fit Polo",
  "tommy-hilfiger-women-v-neck-logo-tee-white": "V-Neck Logo Tee",
  "tommy-hilfiger-women-v-neck-logo-tee-black": "V-Neck Logo Tee",
  "tommy-hilfiger-women-v-neck-logo-tee-navy": "V-Neck Logo Tee",
  "tommy-hilfiger-women-regular-logo-tee-blue": "Regular Logo Tee",
  "tommy-hilfiger-women-repeat-windbreaker-pink": "Repeat Windbreaker",
  "tommy-hilfiger-women-boat-neck-logo-tee-navy": "Boat Neck Logo Tee",
  "tommy-hilfiger-women-essential-zip-thru-tee-black": "Essential Zip-thru Tee",
  "tommy-hilfiger-women-essential-shoulder-strap-white": "Shoulder Strap",
  "tommy-hilfiger-women-essential-shoulder-strap-navy": "Shoulder Strap",
  "tommy-hilfiger-women-ss-regular-logo-tee-grey": "Regular Logo Tee",
  "tommy-hilfiger-women-repeat-windbreaker-white": "Repeat Windbreaker",
  "tommy-hilfiger-women-organic-stripe-tee-red": "Organic Stripe Tee",
  "tommy-hilfiger-women-organic-stripe-tee-navy": "Organic Stripe Tee",
  "tommy-hilfiger-women-organic-badge-skirt-white": "Organic Badge Skirt",
  "tommy-hilfiger-women-down-filled-vest-white": "Down Filled Vest",
  "tommy-hilfiger-women-logo-hoodie-navy": "Logo Hoodie",
  "tommy-hilfiger-women-bodycon-skirt-black-stripe": "BodyCon Skirt",
  "tommy-hilfiger-women-slim-stretch-poplin-shirt-blue": "Slim Poplin Shirt",
  "tommy-hilfiger-women-slim-stretch-poplin-shirt-dark": "Slim Poplin Shirt",
  "tommy-hilfiger-women-slim-stretch-poplin-shirt-white": "Slim Poplin Shirt",
  "tommy-hilfiger-women-slim-fit-stripe-shirt-blue": "Slim Fit Stripe Shirt",
  "tommy-hilfiger-women-down-filled-jacket-red": "Down Filled Jacket",
  "tommy-hilfiger-women-tanktop-white": "Tanktop",
  "tommy-hilfiger-women-tanktop-navy": "Tanktop",
  "tommy-hilfiger-women-knit-jumper-green": "Knit Jumper Soft",
  "timberland-stack-logo-l-s-tee-white": "Stack Logo L/S Tee",
  "tommy-hilfiger-women-slim-stripe-3-4-top-black": "Slim Stripe 3/4 Top",
  "timberland-1973-crew-sweatshirt-black": "1973 Crew Sweatshirt",
  "tommy-hilfiger-women-slim-stripe-3-4-top-blue": "Slim Stripe 3/4 Top",
  "tommy-hilfiger-women-slim-stripe-3-4-top-red": "Slim Stripe 3/4 Top",
  "timberland-backpack-black": "Backpack",
  "timberland-basic-crew-sweatshirt-grey": "Basic Crew Sweatshirt",
  "timberland-basic-crew-sweatshirt-navy": "Basic Crew Sweatshirt",
  "timberland-organic-s-s-tee-black": "Organic S/S Tee",
  "ralph-lauren-tape-shorts-khaki": "Tape Shorts",
  "armani-ea7-core-id-track-pants-navy": "EA7 Core ID Track Pants",
  "armani-ea7-core-id-track-top-navy": "EA7 Core ID Track Top",
  "ralph-lauren-canvas-sneaker-black": "Canvas Sneaker",
  "ralph-lauren-longwood-leather-sneaker-whitie": "Longwood Sneaker",
  "lacoste-women-run-spin-trainers-black": "Run Spin Trainers",
  "lacoste-women-storm-96-athletic-lo-sneakers-white-pink": "Storm 96 Lo",
  "lacoste-women-storm-96-nano-sneakers-white-navy": "Storm 96 Nano",
  "lacoste-women-power-court-sneaker-bleach": "Power Court Sneaker",
  "lacoste-regular-s-s-logo-tee-black": "Regular Logo Tee",
  "armani-ea7-id-logo-zip-hoodie-navy": "EA7 ID Logo Zip Hoodie",
  "armani-ea7-id-logo-zip-hoodie-black": "EA7 ID Logo Zip Hoodie",
  "armani-ea7-id-logo-hoodie-black": "EA7 ID Logo Hoodie",
  "armani-ea7-core-id-s-s-tee-black": "EA7 Core ID Tee",
  "columbia-sweatpants-csc-logo-black": "Sweatpants CSC Logo",
  "columbia-sweatpants-csc-logo-navy": "Sweatpants CSC Logo",
  "columbia-powder-pass-jacket-grey": "Powder Pass Jacket",
  "columbia-csc-logo-basic-tee-blue": "CSC Logo Basic Tee",
  "columbia-logo-shorts-black": "Logo Shorts",
  "columbia-csc-basic-tee-black": "CSC Basic Tee",
  "columbia-logo-crew-sweat-black": "Logo Crew Sweat",
  "columbia-csc-logo-hoodie-grey": "CSC Logo Hoodie",
  "columbia-logo-crew-sweat-navy": "Logo Crew Sweat",
  "columbia-csc-logo-hoodie-black": "CSC Logo Hoodie",
  "columbia-csc-logo-hoodie-navy": "CSC Logo Hoodie",
  "nike-women-dri-fit-polo-red": "Dri-FIT Polo",
  "nike-women-dri-fit-polo-white": "Dri-FIT Polo",
  "nike-women-dri-fit-polo-black": "Dri-FIT Polo",
  "nike-women-dri-fit-trackjacket-red": "Dri-FIT Trackjacket",
  "nike-women-dri-fit-1-4-zip-academy-red": "Dri-FIT 1/4 Zip Academy",
  "nike-women-academy-pants-black": "Academy Pants",
  "nike-park-s-s-tee-white": "Park S/S Tee",
  "ralph-lauren-oxford-slim-pique-shirt-sky": "Oxford Slim Shirt",
  "ralph-lauren-oxford-slim-pique-shirt-bleach": "Oxford Slim Shirt",
  "ralph-lauren-s-s-crew-tee-black": "Crew Tee",
  "calvin-klein-adj-leather-belt-black": "ADJ Leather Belt",
  "calvin-klein-institutional-logo-slim-tee-navy": "Institutional Slim Tee",
  "calvin-klein-institutional-logo-slim-tee-snow": "Institutional Slim Tee",
  "calvin-klein-institutional-s-s-chest-tee-grey": "Institutional Tee",
  "calvin-klein-institutional-s-s-chest-tee-black": "Institutional Tee",
  "calvin-klein-institutional-core-sweatshirt-grey": "Core Sweat",
  "tommy-hilfiger-women-logo-icon-bandeau-navy": "Logo Icon Bandeau",
  "tommy-hilfiger-women-padded-logo-bralette-red": "Padded Logo Bralette",
  "tommy-hilfiger-women-padded-logo-bralette-white": "Padded Logo Bralette",
  "tommy-hilfiger-women-logo-bralette-white": "Logo Bralette",
  "tommy-hilfiger-women-logo-bralette-red": "Logo Bralette",
  "tommy-hilfiger-women-logo-bralette-navy": "Logo Bralette",
  "tommy-hilfiger-women-thong-3-pack-navy": "Thong 3-pack",
  "tommy-hilfiger-women-thong-3-pack-multi": "Thong 3-pack",
  "ralph-lauren-oxford-custom-pique-shirt-blue": "Oxford Custom Shirt",
  "lacoste-women-power-court-sneaker-white": "Power Court Sneaker",
  "ralph-lauren-oxford-custom-pique-shirt-white": "Oxford Custom Shirt",
  "polo-ralph-lauren-slim-fit-polo-jamaica": "Slim Fit Polo Jamaica",
  "lacoste-women-carnaby-sneaker-white": "Carnaby Sneaker",
  "polo-ralph-lauren-custom-slim-fit-polo-jamaica": "Custom Slim Polo",
  "lacoste-reversible-belt-box-night": "2 in 1 Belt Box Leather",
  "lacoste-reversible-belt-box-black": "2 in 1 Belt Box Leather",
  "lacoste-leather-card-wallet-black": "Leather Card Wallet",
  "armani-ea7-classic-low-sneakers-white": "EA7 Sneaker",
  "armani-ea7-padded-light-jacket-navy": "EA7 Padded Jacket",
  "armani-ea7-quilted-vest-grey": "EA7 Quilted Vest",
  "armani-ea7-quilted-vest-black": "EA7 Quilted Vest",
  "armani-ea7-core-l-s-polo-navy": "EA7 Core L/S Polo",
  "armani-ea7-core-l-s-polo-black": "EA7 Core L/S Polo",
  "armani-ea7-core-id-polo-shirt-navy": "EA7 Core ID Polo Shirt",
  "armani-ea7-core-id-polo-shirt-black": "EA7 Core ID Polo Shirt",
  "armani-ea7-core-id-l-s-tee-white": "EA7 Core ID L/S Tee",
  "armani-ea7-core-id-l-s-tee-navy": "EA7 Core ID L/S Tee",
  "armani-ea7-core-id-l-s-tee-black": "EA7 Core ID L/S Tee",
  "armani-ea7-knitted-shield-logo-jumper-asphalt": "EA7 Shield Knit",
  "nike-women-park-training-tee-red": "Park Training Tee",
  "nike-women-park-training-tee-white": "Park Training Tee",
  "nike-women-park-training-tee-black": "Park Training Tee",
  "tommy-hilfiger-womens-leggings-navy": "Leggings Side Logo",
  "adidas-women-condivo-track-jacket-grey": "Condivo Track Jacket",
  "adidas-women-condivo-track-jacket-black": "Condivo Track Jacket",
  "adidas-women-condivo-1-4-zip-navy": "Condivo 1/4 Zip",
  "adidas-women-condivo-1-4-zip-black": "Condivo 1/4 Zip",
  "nike-new-swoosh-sweatshirt-khaki": "New Swoosh Sweat",
  "hugo-boss-tank-top-3-pack-white": "Tank Top 3-pack",
  "cr7-trunks-5-pack-black": "Trunks 5-Pack",
  "calvin-klein-women-s-s-crew-neck-tee-grey": "S/S Crew Neck Tee",
  "calvin-klein-s-s-v-neck-stretch-logo-tee-black": "V-Neck 2-Pack Tee",
  "calvin-klein-s-s-stretch-logo-tee-white": "2-Pack Stretch Tee",
  "tommy-hilfiger-women-soft-touch-knit-v-neck-navy": "Soft Touch Knit V-Neck",
  "ellesse-brufa-crew-sweatshirt-black": "Brufa Crew Sweat",
  "tommy-hilfiger-women-tjw-side-slit-jacket-black": "TJW Side Slit Jacket",
  "champion-women-logo-beach-towel-red": "Logo Beach Towel",
  "champion-women-scarf-black": "Scarf",
  "ralph-lauren-slim-denim-shirt-washed": "Slim Chambray Shirt",
  "ralph-lauren-slim-pique-shirt-white": "Slim Pique Shirt",
  "polo-ralph-lauren-custom-slim-fit-polo-canterbury": "Custom Slim Fit Polo",
  "ralph-lauren-s-s-crew-tee-white": "Crew Tee",
  "tommy-hilfiger-women-tjw-crew-sweatshirt-navy": "TJW Crew Sweatshirt",
  "tommy-hilfiger-women-tjw-crew-knit-black": "TJW Crew Knit",
  "tommy-hilfiger-women-tjw-logo-tee-white": "TJW Logo Tee",
  "tommy-hilfiger-women-tjw-essential-tee-grey": "TJW Essential Tee",
  "tommy-hilfiger-women-tjw-logo-tee-navy": "TJW Logo Tee",
  "nike-women-vi-park-s-s-tee-red": "VI Park S/S Tee",
  "nike-women-park-shorts-red": "Park Shorts",
  "nike-women-park-shorts-navy": "Park Shorts",
  "nike-women-vi-park-s-s-tee-white": "VI Park S/S Tee",
  "nike-tiempo-tee-navy": "Tiempo Tee",
  "nike-vi-l-s-training-tee-bordeaux": "VI L/S Training Tee Dark",
  "tommy-hilfiger-women-iconic-bralette-grey": "Iconic Bralette",
  "tommy-hilfiger-women-brazilian-brief-white": "Brazilian Brief",
  "tommy-hilfiger-women-brazilian-brief-grey": "Brazilian Brief",
  "tommy-hilfiger-women-flag-logo-bralette-pink": "Flag Logo Bralette",
  "under-armour-rival-joggers-black": "Rival joggers",
  "under-armour-tech-1-4-zip-carbon": "Tech 1/4 Zip",
  "under-armour-tech-1-4-zip-black": "Tech 1/4 Zip",
  "champion-scarf-black": "Scarf",
  "under-armour-wordmark-tee-white": "Wordmark Tee",
  "under-armour-wordmark-tee-black": "Wordmark Tee",
  "under-armour-boxed-tee-grey": "Boxed Tee",
  "under-armour-foundati-tee-grey": "Foundati Tee",
  "dsquared2-zip-hoodie-black": "Zip Hoodie",
  "dsquared2-knit-pullover-melange": "Knit Pullover",
  "dsquared2-skater-jean-jeans-blue": "Skater Slim Jeans",
  "dsquared2-cool-guy-denim-jeans-blue": "Cool Guy Denim Jeans",
  "dsquared2-slim-jean-jeans-navy": "Slim Jean Jeans",
  "dsquared2-blackout-logo-tee-grey": "Blackout Logo Tee",
  "dsquared2-drip-logo-tee-white": "Drip Logo Tee",
  "ellesse-women-tropea-trainer-pink": "Tropea Trainer",
  "ellesse-women-tropea-trainer-grey": "Tropea Trainer",
  "ellesse-women-tropea-trainer-white": "Tropea Trainer",
  "ellesse-women-alzina-trainer-white": "Alzina Trainer",
  "ellesse-women-alzina-trainer-grey": "Alzina Trainer",
  "rains-women-1201-jacket-navy": "1201 Jacket",
  "champion-new-script-hoodie-green": "New Script Hoodie",
  "ralph-lauren-bomber-jacket-black": "Bomber Jacket",
  "nike-vi-s-s-training-tee-navy": "VI S/S Training Tee",
  "nike-vi-s-s-training-tee-black": "VI S/S Training Tee",
  "nike-women-park-pants-black": "Park Pants",
  "nike-women-park-shorts-white": "Park Shorts",
  "nike-women-park-shorts-black": "Park Shorts",
  "calvin-klein-women-s-s-crew-neck-tee-red": "S/S Crew Neck Tee",
  "calvin-klein-women-s-s-crew-neck-tee-grape": "S/S Crew Tee White",
  "calvin-klein-women-modern-dot-unlined-bralette-black": "Modern Dot Bralette",
  "calvin-klein-women-modern-dot-unlined-bralette-white": "Modern Dot Bralette",
  "calvin-klein-women-one-icon-bandeau-white": "One Icon Bandeau",
  "champion-logo-beach-towel-red": "Logo Beach Towel",
  "tommy-hilfiger-women-iconic-bralette-navy": "Iconic Bralette",
  "tommy-hilfiger-women-iconic-bralette-white": "Iconic Bralette",
  "tommy-hilfiger-women-essential-logo-bralette-black": "Essential Bralette",
  "tommy-hilfiger-women-essential-logo-bralette-rose": "Essential Bralette",
  "tommy-hilfiger-women-essential-logo-bralette-grey": "Essential Bralette",
  "tommy-hilfiger-women-essential-logo-bralette-navy": "Essential Bralette",
  "tommy-hilfiger-women-waistband-logo-leggings-grey": "Waistband Leggings",
  "tommy-hilfiger-women-waistband-logo-leggings-navy": "Waistband Leggings",
  "tommy-hilfiger-women-cross-back-training-bralette-navy": "Cross Back Bralette",
  "tommy-hilfiger-women-micro-triangle-bralette-black": "Micro Bralette",
  "tommy-hilfiger-women-micro-triangle-bralette-navy": "Micro Bralette",
  "tommy-hilfiger-women-authentic-ctn-bralette-navy": "Authentic CTN Bralette",
  "tommy-hilfiger-women-authentic-ctn-bralette-grey": "Authentic CTN Bralette",
  "tommy-hilfiger-women-authentic-logo-bralette-white": "Authentic Bralette",
  "tommy-hilfiger-women-authentic-logo-bralette-grey": "Authentic Bralette",
  "tommy-hilfiger-women-thong-3-pack-white": "Thong 3-pack",
  "tommy-hilfiger-women-padded-triangle-bralette-pale": "Padded Bralette",
  "tommy-hilfiger-women-padded-triangle-bralette-navy": "Padded Bralette",
  "tommy-hilfiger-women-flex-cotton-bralette-white": "Flex Cotton Bralette",
  "tommy-hilfiger-women-flex-cotton-bralette-navy": "Flex Cotton Bralette",
  "levis-colorblock-windbreaker-night-green": "Windbreaker",
  "tommy-jeans-logo-sweatshirt-navy": "Logo Crew Sweatshirt",
  "tommy-jeans-zip-track-jacket-white": "Track Jacket",
  "tommy-hilfiger-essential-stripe-shirt-soft-red": "Stripe Shirt Soft",
  "tommy-hilfiger-performance-logo-bra-red": "Sport Bra",
  "tommy-hilfiger-new-performance-tanktop-navy": "Sport Tanktop",
  "tommy-hilfiger-performance-tanktop-red": "Sport Tanktop",
  "tommy-hilfiger-performance-s-s-logo-tee-navy": "Sport Tee",
  "tommy-hilfiger-5-jacquard-shorts-red": "\"5\" JACQUARD Shorts",
  "tommy-hilfiger-5-jacquard-shorts-navy": "\"5\" JACQUARD Shorts",
  "calvin-klein-slim-chino-shorts-navy": "Slim Chino Shorts",
  "calvin-klein-slim-signature-shorts-grey": "Slim Signature Shorts",
  "calvin-klein-badge-jacket-navy": "Badge Jacket",
  "calvin-klein-women-true-icon-tee-red": "True Icon Tee",
  "calvin-klein-women-true-icon-tee-grey": "True Icon Tee",
  "calvin-klein-icon-denim-shorts-denim": "Icon Denim Shorts",
  "calvin-klein-icon-denim-shorts-black": "Icon Denim Shorts",
  "calvin-klein-icon-denim-shorts-light": "Icon Denim Shorts",
  "champion-full-zip-training-jacket-navy-red": "Zip Jacket",
  "nike-vi-l-s-training-tee-red": "VI L/S Training Tee",
  "nike-dri-fit-sweat-jersey-navy": "Dri-FIT Sweat",
  "nike-dri-fit-sweat-jersey-black": "Dri-FIT Sweat",
  "nike-park-polo-navy": "Park Polo",
  "nike-park-polo-black": "Park Polo",
  "lacoste-regular-s-s-polo-pike-navy": "Classic Polo Piké",
  "lacoste-regular-s-s-polo-pike-black": "Classic Polo Piké",
  "lacoste-regular-s-s-polo-pike-green": "Classic Polo Piké",
  "lacoste-regular-s-s-polo-pike-bordeaux": "Polo Piké Bordeaux",
  "lacoste-slim-s-s-polo-pike-red": "Corrida Slim Polo",
  "lacoste-slim-s-s-polo-pike-black": "Slim S/S Polo Piké",
  "lacoste-slim-s-s-polo-pike-navy": "Slim S/S Polo Piké",
  "ralph-lauren-oxford-custom-shirt-navy": "Oxford Custom Shirt",
  "champion-classics-s-s-logo-tee-black": "Classics S/S Logo Tee",
  "champion-logo-block-tee": "Logo Block Tee",
  "ralph-lauren-stretch-joggers-navy": "Stretch Joggers",
  "levis-graphic-anorak-black": "Graphic Anorak",
  "nike-vi-l-s-training-tee-navy": "VI L/S Training Tee",
  "nike-dri-fit-shorts-grey": "Dri-FIT Shorts",
  "nike-vi-l-s-training-tee-white": "VI L/S Training Tee",
  "polo-ralph-lauren-l-s-poloshirt-black": "L/S Poloshirt",
  "polo-ralph-lauren-l-s-poloshirt-navy": "L/S Poloshirt",
  "tommy-hilfiger-original-s-s-logo-tee-grey": "Original S/S Logo Tee",
  "tommy-hilfiger-original-s-s-logo-tee-white": "Original S/S Logo Tee",
  "calvin-klein-women-s-s-crew-neck-tee-rose": "S/S Crew Neck Tee",
  "calvin-klein-women-s-s-crew-neck-tee-black": "S/S Crew Neck Tee",
  "calvin-klein-trunks-3-pack-stripe": "Trunks 3-pack Stripe",
  "under-armour-tech-tee-grey": "Tech Tee",
  "guess-original-logo-sweatshirt-black": "Sweat Original",
  "guess-iron-born-sweatshirt-grey": "Iron Born Sweatshirt",
  "hugo-boss-trunks-3-pack-color-994": "3-pack Trunks",
  "tommy-hilfiger-women-flag-logo-bralette-navy": "Flag Logo Bralette",
  "tommy-hilfiger-women-authentic-ctn-bralette-white": "Authentic CTN Bralette",
  "tommy-hilfiger-women-authentic-logo-bralette-navy": "Authentic Bralette",
  "tommy-hilfiger-women-modern-stripe-bralette-navy": "Stripe Bralette",
  "tommy-hilfiger-women-bikini-briefs-3-pack-multi": "Bikini Briefs 3-pack",
  "tommy-hilfiger-women-bikini-briefs-3-pack-navy": "Bikini Briefs 3-pack",
  "tommy-hilfiger-women-iconic-bralette-black": "Iconic Bralette",
  "calvin-klein-women-unlined-bralette-black": "Unlined Bralette",
  "nike-dri-fit-shorts-white": "Dri-FIT Shorts",
  "fila-umed-l-s-polo-black": "Logo L/S Polo",
  "fila-paddy-track-pants-black": "Paddy Track Pants",
  "hugo-boss-trunks-3-pack-color-999": "Trunks 3-pack",
  "champion-icon-sweatshirt-camo": "Icon Sweatshirt Camo",
  "champion-american-classics-sweatshirt-grey": "American Sweat",
  "ralph-lauren-l-s-crew-tee-grey": "L/S Tee",
  "ralph-lauren-l-s-crew-tee-black": "L/S Tee",
  "ralph-lauren-s-s-crew-tee-grey": "Crew Tee",
  "ralph-lauren-s-s-crew-tee-navy": "Crew Tee",
  "ralph-lauren-l-s-crew-tee-navy": "L/S Tee",
  "armani-ea7-bomber-jacket-black": "EA7 Zip Up Jacket",
  "armani-ea7-bomber-jacket-navy": "EA7 Zip Up Jacket",
  "dsquared2-signature-logo-t-shirt-red": "Boy Scout Tee",
  "ralph-lauren-oxford-custom-shirt-black": "Oxford Custom Shirt",
  "gift-card": "Gift Card",
  "fila-5-pack-headbands-multi": "5-pack Headbands",
  "calvin-klein-true-icon-logo-tee-grey": "True Icon Tee Grey",
  "nike-club-sweatshirt-grey": "Club Sweatshirt",
  "champion-swim-shorts-bermuda-red": "Shorts Bermuda",
  "ralph-lauren-l-s-crew-tee-white": "L/S Tee",
  "calvin-klein-trunks-3-pack-multi": "Trunks 3-pack",
  "tommy-hilfiger-tank-top-3-pack-white": "3-pack Tank Top",
  "tommy-hilfiger-regular-tee-white": "T-shirt",
  "tommy-hilfiger-regular-crew-sweatshirt-black": "Crew Sweat",
  "tommy-hilfiger-regular-hoodie-black": "Hoodie",
  "u-s-polo-assn-zip-hoodie-otto-grey": "Otto Zip Hoodie",
  "u-s-polo-assn-zip-hoodie-otto-black": "Otto Zip Hoodie",
  "u-s-polo-assn-half-zip-pullover-kurt-black": "Kurt Half-Zip",
  "u-s-polo-assn-half-zip-pullover-kurt-army": "Kurt Half-Zip",
  "u-s-polo-assn-anton-jacket-black": "Anton Jacket",
  "u-s-polo-assn-sweatpants-terkel-black": "Terkel Pants",
  "u-s-polo-assn-sweatpants-terkel-navy": "Terkel Pants",
  "u-s-polo-assn-half-zip-cable-knit-romeo-cloud": "Romeo Half-Zip",
  "u-s-polo-assn-half-zip-cable-knit-romeo-navy": "Romeo Half-Zip",
  "u-s-polo-assn-rider-cap-black": "Rider Cap",
  "u-s-polo-assn-mika-cap-navy": "Mika Cap"
});
